import { BasePresenter } from "@presenters/base/base.presenter";
import { ProaService, IProaService } from "@services/proyecta/proa-form.service";
import { ISPFEService, SPFEService } from "@services/proyecta/spfe.service";
import {  FollowupService, IFollowupService } from "@services/proyecta/followup.service";
import { useSelector } from "react-redux";
import { Constants, Utilities, String, Enums, Dictionary } from "@utils";
import { ILang } from "@models/*";
import Swal from 'sweetalert2';

export class PopAdminPresenter extends BasePresenter<any>{
    private popService: IProaService;
    protected _feService: ISPFEService;
    private followupService: IFollowupService;
    public allBudgets: any;
    public allBudgetDetails: any;
    public stepsData: any;
    public formMasters: any;
    public formMastersFollowup: any;
    public currentLang: ILang;
    public currentLabels: any;
    public followupLabels: Dictionary<string, string>;
    public followUpData: any;
    public openModal: any;
    public finishAlert: any;
    public infoToDelete: any;
    public params: any;

    constructor(view?: any) {
        super(view);
        this.params = useSelector(this.context.sessionStore.selectParams);
        this.allBudgets = useSelector(this.context.popStore.selectAllBudgets);
        this.allBudgetDetails = useSelector(this.context.popStore.selectAllBudgetDetails);
        this.stepsData = useSelector(this.context.popStore.selectStepsData);
        this.followUpData = useSelector(this.context.popStore.selectFollowUpData);
        this.currentLang = useSelector(this.context.sessionStore.selectLang) as any;
        this.formMasters = useSelector(this.context.proaStore.selectFormMasters) as any;
        this.currentLabels = useSelector(this.context.sessionStore.selectLabels);
        this.openModal = useSelector(this.context.popStore.selectOpenModal);
        this.finishAlert = useSelector(this.context.popStore.selectFinishAlert);
        this.infoToDelete = useSelector(this.context.popStore.selectInfoToDelete);
        this.formMastersFollowup = useSelector(this.context.followupStore.selectFormMasters);
        this.followupLabels = useSelector(this.context.followupStore.selectLabels);

        this.handleOpenModal = this.handleOpenModal.bind(this);
        this.onProjectChanged = this.onProjectChanged.bind(this);
        this.onSelectionChangedStep = this.onSelectionChangedStep.bind(this);
        this.onSubProjectChanged = this.onSubProjectChanged.bind(this);
        this.getDeleteColumn = this.getDeleteColumn.bind(this);
        this.popService = new ProaService();
        this._feService = new SPFEService();
        this.followupService = new FollowupService();
    }

    public async initialize(){ 
        
        this.dispatcherProgress(50);   

        if(!this.formMasters) this.dispatcher(this.context.proaStore.getAllFormMasters());
        if(!this.formMastersFollowup) this.dispatcher(this.context.followupStore.getAllFormMasters()); 
        this.dispatcher(this.context.followupStore.getLabels());
        this.dispatcher(this.context.popStore.getAllBudgets()); 
        this.dispatcher(this.context.popStore.getAllBudgetDetails());
        this.dispatcher(this.context.popStore.getStepsData());
        this.dispatcher(this.context.popStore.getAllFollowupData());

        this.dispatcherProgress(60); 

        const [FFRR, FFEE, ind, ben, fin] = await Promise.all([
            this.popService.getDefinitionColumnsProaFR(this.currentLang?.id), 
            this._feService.getDataColumns(this.currentLang?.id),
            this.followupService.getDefinitionColumnsIndicators(this.currentLang?.id), 
            this.followupService.getDefinitionColumnsBeneficiaries(this.currentLang?.id),
            this.followupService.getDefinitionColumnsFinancial(this.currentLang?.id)
            
        ])  as any;

        this.dispatcherProgress(70); 

        this.view.state.setColumns({FFRR, FFEE})
        this.view.state.setColumnsModal({ind, ben, fin})
    }

    public async unSetLoading(){
        this.dispatcherProgress(90); 

        setTimeout(() => {
            this.dispatcherUnsetSetLoading();
        }, 500);
    }

    public async onCloseModal(){
        this.dispatcher(this.context.popStore.handleOpenModal(false)); 
        setTimeout(() => {
            Utilities.showConfirmation2(this.currentLabels.get("MessageDeletingWithFollowUp"), this.currentLabels.get("MessageDeletingWithFollowUp2"), this.currentLabels.get("MessageToSee"), this.handleOpenModal)
            .then(async (res) => {
                if(res){
                    await this.deleteItems(this.infoToDelete.itemsToDelete)
                    this.clear()
                }
            })
        }, 20);
    }

    public async clear(){
        this.dispatcher(this.context.popStore.showFinishAlert(true));
        this.dispatcher(this.context.popStore.getStepsData(true)); 
        this.dispatcher(this.context.popStore.getAllFollowupData(true));
        this.dispatcher(this.context.popStore.handleInfoToDelete(null, null));
        
        this.dispatcher(this.context.popStore.getStepsData()); 
        this.dispatcher(this.context.popStore.getAllFollowupData());
    }

    public async showFinishAlert(){
        this.dispatcher(this.context.popStore.showFinishAlert(false));
        Utilities.notifySuccess(this.currentLabels.get("RemoveMessage"), this.currentLabels.get("SuccessfulRemoval"))
    }

    public async getProjects(){ 
        let newData: any[] = []  
        let currentData: any[] = this.allBudgets || []
        
        for (const data of currentData) {
            if(data?.CodigoProyecto?.Title && !data.PPresPresupuestoId){
                let value = `${data?.CodigoProyecto?.Title} - ${data.Title || ''}`
                newData.push(value)
            }
        }   

        this.view.state.setProjects(newData);
    }

    public getDisplayExpression(item:any){
        if(item === undefined) return "..."
        return item;
    }

    public onProjectChanged(e:any){ 
        let current = this.allBudgets?.find((x: any) => (x.CodigoProyecto?.Title === e?.value?.split("-")?.[0]?.trim() && !x.PPresPresupuestoId))
        let childsBudget = this.allBudgets?.filter((y: any) => y.PPresPresupuestoId === current.Id) || []
        let budgetsId = [...childsBudget?.map((x: any) => x.Id), current.Id]
        let details = this.allBudgetDetails?.filter((x: any) => budgetsId.includes(x.PPresPresupuestoId))
        let filterDetails = this.selectTabs(details || [])
        let hasFFRR = false
        
        const subData: any = [];
        filterDetails?.forEach((item:any) => {
            let value = this.currentLabels.get("ProaTab-Subproyectos ffrr")
            if(item?.PPresCodSubvencion?.Title){
                value = `${item?.PPresCodSubvencion?.Title} - ${item.OCTAVIAFinanciadorSap?.Title || ''}` 
                subData.push(value);
            }else if(!hasFFRR){
                subData.unshift(value)
                hasFFRR = true
            }
        });
        this.view.state.setSubProjects(subData);
        this.view.state.setDetails(filterDetails);
        this.view.state.setProjectSelected(e.value);
        this.view.state.setSubProjectSelected(null);
        this.view.state.setStepsData(null)
    }

    public onSubProjectChanged(e:any, reload?: boolean){ 
        let value = reload ? this.view.state.subProjectSelected?.split("-")?.[0]?.trim() : e?.value?.split("-")?.[0]?.trim()
        let isFFRR = reload ? !this.view.state.subProjectSelected?.includes("-") : !e?.value?.includes("-")

        const current = this.view.state.details?.find((x: any) => isFFRR ? !x.PPresCodSubvencionId : value === x?.PPresCodSubvencion?.Title);
        let currentData = this.getCurrentSteps(current, this.stepsData)
        this.view.state.setStepsData(currentData)
        if(!reload) this.view.state.setSubProjectSelected(e.value);
    }

    public getCurrentSteps(current: any, stepsData: any){ 
        let father = this.allBudgets?.find((x: any) => (x.CodigoProyecto?.Title === this.view.state.projectSelected?.split("-")?.[0]?.trim() && !x.PPresPresupuestoId))
        let currentData: any = {}
        let PPresCodSubvencionId = current?.PPresCodSubvencionId || null

        let step1 = stepsData.step1.base?.find((x: any) => x.PPresPresupuestoId === father?.Id && x.PPresCodSubvencionId === PPresCodSubvencionId)
        let step2 = stepsData.step2.base?.filter((x: any) => x.PPresPresupuestoId === father?.Id && x.PPresCodSubvencionId === PPresCodSubvencionId)
        let stepSDC = stepsData.stepSDC.base?.filter((x: any) => x.PPresPresupuestoId === father?.Id && x.PPresCodSubvencionId === PPresCodSubvencionId)
        let step3 = stepsData.step3.base?.filter((x: any) => x.PPresPresupuestoId === father?.Id && x.PPresCodSubvencionId === PPresCodSubvencionId)

        currentData.step1 = {
            genericInfo: step1,
            years: stepsData.step1.years?.filter((x: any) => x.PProaFRStep1Id === step1?.Id ),
            beneficiaries: stepsData.step1.yearsBeneficiaries?.filter((x: any) => x.PPresPresupuestoId === father?.Id && x.PProaFRStep1Id === step1?.Id)
        }

        currentData.step2 = step2.map((sdc: any) => {
            let newStep2: any = {}
            newStep2.genericInfo = sdc
            newStep2.years = stepsData.step2.years?.filter((x: any) => x.PProaFRStep2Id === sdc?.Id )

            return newStep2
        })

        currentData.stepSDC = stepSDC.map((s2: any) => {
            let newStepSDC: any = {}
            newStepSDC.genericInfo = s2
            newStepSDC.years = stepsData.stepSDC.years?.filter((x: any) => x.PProaContrapartidaId === s2?.Id )

            return newStepSDC
        })

        currentData.step3 = step3.map((s3: any) => {
            let newStep3: any = {}
            newStep3.genericInfo = s3
            newStep3.years = stepsData.step3.years?.filter((x: any) => x.PProaFRStep3Id === s3?.Id )

            return newStep3
        })
       
        currentData.step4 = { }
        
        let objetives = stepsData.step4.objetives?.filter((x: any) => x.PPresPresupuestoId === father?.Id && x.PPresCodSubvencionId === PPresCodSubvencionId)
        let mri = stepsData.step4.mri?.base?.filter((x: any) => x.PPresPresupuestoId === father?.Id && x.PPresCodSubvencionId === PPresCodSubvencionId)

        currentData.step4.mri = mri.map((auxMri: any) => {
            let newMri: any = {}
            newMri.genericInfo = auxMri
            newMri.years = stepsData.step4.mri?.years?.filter((x: any) => x.PProaStep4AdaptacionMRIId === auxMri?.Id )

            return newMri
        })

        currentData.step4.objetives = objetives.map((obj: any) => {
            let newObj: any = {}
            newObj.genericInfo = obj

            let specificObjetives = stepsData.step4.specificObjetives?.base?.filter((x: any) => x.PProaFEStep4Id === obj?.Id )
            newObj.specificObjetives = specificObjetives.map((spe: any) => {
                let newSpe: any = {}
                newSpe.genericInfo = spe

                newSpe.years = stepsData.step4.specificObjetives?.years?.filter((x: any) => x.PProaFEStep4InidicadorId === spe?.Id )
                return newSpe
            })

            let results = stepsData.step4.results?.base?.filter((x: any) => x.PProaFEStep4Id === obj?.Id)
            newObj.results = results.map((res: any) => {
                let newRes: any = {}
                newRes.genericInfo = res

                let details = stepsData.step4.results?.details?.filter((x: any) => x.PProaFEStep4ResultadosEsperadosId === res?.Id)

                newRes.details = details.map((det: any) => {
                    let newDet: any = {}
                    newDet.genericInfo = det
                    newDet.years = stepsData.step4.results?.years?.filter((x: any) => x.PProaFEStep4ResultadoDetalleId === det?.Id )
                    return newDet
                })
    
                let activities = stepsData.step4.activities?.base?.filter((x: any) => x.PProaFEStep4ResultadosEsperadosId === res?.Id )

                newRes.activities = activities.map((act: any) => {
                    let newAct: any = {}
                    newAct.genericInfo = act
                    newAct.years = stepsData.step4.activities?.years?.filter((x: any) => x.PProaFEStep4ActividadId === act?.Id )
                    return newAct
                })
                
                return newRes
            })
            
            return newObj
        })
        
        return currentData;
    }

    private selectTabs(data: any) {
        const tabsName: Array<string> = [];
        const result: Array<any> = [];
    
        data?.forEach((tab: any) => {
          const name = tab?.PPresCodSubvencion?.OCTAVIACodigoSubvencion;
          const indName = name?.substring(0, 1);
          if (!Utilities.isNullEmptyObject(indName)) {
            let addResult = false;
            switch (indName) {
              case Enums.Prefix.Contributions.toString():
                addResult = false;
                break;
              case Enums.Prefix.Donations.toString():
                addResult = tabsName.indexOf(name) === -1;
                break;
              default:
                addResult = Number.isInteger(Number.parseInt(indName)) && tabsName.indexOf(name) === -1;
                break;
            }
            if (addResult) {
              tabsName.push(name);
              result.push(tab);
            }
          }else if (tabsName.indexOf(name) === -1) {
            tabsName.push(name);
            result.push(tab);
          }
        });
        return result;
    }
    
    // ***** COLUMNS *****

    public getDataColumnsStep1(masters: any) {
        const columns: any[] = [];
        const columns2: any[] = [];
        columns.push(this.getCommonFieldProps(Enums.ProaBasicFields.IndicadorLE1, masters));
        columns.push(this.getCommonFieldProps(Enums.ProaBasicFields.PProaUnidadMedida, masters));
        columns.push(this.getCommonFieldProps(Enums.ProaBasicFields.LineaBase, masters));
        columns.push(this.getCommonFieldProps(Enums.ProaBasicFields.PProaAnioLineaBase, masters));
        columns.push(this.getCommonFieldProps(Enums.ProaBasicFields.MetaFinal, masters));
        columns.push(this.getDeleteColumn("Step1"))

        let metaYear = this.getCommonFieldProps(Enums.ProaBasicFields.Meta, masters);
        metaYear.fieldType = Enums.FieldTypes.Text
        metaYear.title = this.currentLabels.get("Anio")
        columns2.push(metaYear)
        columns2.push(this.getCommonFieldProps(Enums.ProaBasicFields.Meta, masters, true));
        columns2.push(this.getDeleteColumn("Step1", true))
        this.getDataSourceStep1(masters)

        return {auxCol:columns, auxYearCol: columns2}
    }

    public getDataColumnsStep1BF(masters: any) {
        const columns: any[] = [];
        columns.push(this.getCommonFieldProps(Enums.ProaBasicFields.BeneficiarioAnio, masters));
        columns.push(this.getCommonFieldProps(Enums.ProaBasicFields.TotalHombres, masters));
        columns.push(this.getCommonFieldProps(Enums.ProaBasicFields.TotalMujeres, masters));
        columns.push(this.getCommonFieldProps(Enums.ProaBasicFields.TotalGeneral, masters));
        columns.push(this.getDeleteColumn("Step1Bf", true))
        this.getDataSourceStep1BF()

        return columns
    }

    public getDataColumnsStep2(masters: any) {
        const columns: any[] = [];
        const columns2: any[] = [];

        columns.push(this.getCommonFieldProps(Enums.ProaBasicFields.Implementador, masters));
        columns.push(this.getCommonFieldProps(Enums.ProaBasicFields.TotalImplementadores, masters));
        columns.push(this.getDeleteColumn("Step2"))
        

        let metaYear = this.getCommonFieldProps(Enums.ProaBasicFields.Meta, masters);
        metaYear.fieldType = Enums.FieldTypes.Text
        metaYear.title = this.currentLabels.get("Anio")
        columns2.push(metaYear)
        columns2.push(this.getCommonFieldProps(Enums.ProaBasicFields.Meta, masters, true));
        columns2.push(this.getDeleteColumn("Step2", true))
        this.getDataSourceStep2()

        return {auxCol: columns, auxYearCol: columns2}
    }

    public getDataColumnsStep3Loc(masters: any) {
        const columns: any[] = [];
        const columns2: any[] = [];
        columns.push(this.getCommonFieldProps(Enums.ProaBasicFields.Location, masters));
        columns.push(this.getCommonFieldProps(Enums.ProaBasicFields.TotalLocation, masters));
        columns.push(this.getDeleteColumn("Step3Loc"))

        let metaYear = this.getCommonFieldProps(Enums.ProaBasicFields.Meta, masters);
        metaYear.fieldType = Enums.FieldTypes.Text
        metaYear.title = this.currentLabels.get("Anio")
        columns2.push(metaYear)
        columns2.push(this.getCommonFieldProps(Enums.ProaBasicFields.Meta, masters, true));
        columns2.push(this.getDeleteColumn("Step3Loc", true))
        this.getDataSourceStep3Loc()

        return {auxCol: columns, auxYearCol: columns2}
    }

    public getDataColumnsStep3Adt(masters: any) {
        const columns: any[] = [];
        const columns2: any[] = [];
        columns.push(this.getCommonFieldProps(Enums.ProaBasicFields.ADT, masters));
        columns.push(this.getCommonFieldProps(Enums.ProaBasicFields.TotalADT, masters));
        columns.push(this.getDeleteColumn("Step3Adt"))

        let metaYear = this.getCommonFieldProps(Enums.ProaBasicFields.Meta, masters);
        metaYear.fieldType = Enums.FieldTypes.Text
        metaYear.title = this.currentLabels.get("Anio")
        columns2.push(metaYear)
        columns2.push(this.getCommonFieldProps(Enums.ProaBasicFields.Meta, masters, true));
        columns2.push(this.getDeleteColumn("Step3Adt", true))
        this.getDataSourceStep3Adt()

        return {auxCol2: columns, auxYearCol2: columns2}
    }

    public getDataColumnsStepSdc(masters: any) {
        const columns: any[] = [];
        const columns2: any[] = [];

        columns.push(this.getCommonFieldProps(Enums.ProaBasicFields.PProaTipoContrapartida, masters));
        columns.push(this.getCommonFieldProps(Enums.ProaBasicFields.IdContrapartida, masters));
        columns.push(this.getCommonFieldProps(Enums.ProaBasicFields.TotalContrapartidas, masters));
        columns.push(this.getDeleteColumn("StepSdc"))


        let metaYear = this.getCommonFieldProps(Enums.ProaBasicFields.Meta, masters);
        metaYear.fieldType = Enums.FieldTypes.Text
        metaYear.title = this.currentLabels.get("Anio")
        columns2.push(metaYear)
        columns2.push(this.getCommonFieldProps(Enums.ProaBasicFields.Meta, masters, true));
        columns2.push(this.getDeleteColumn("StepSdc", true))
        this.getDataSourceStepSdc() 

        return {auxCol: columns, auxYearCol: columns2}
    }

    public getDataColumnsStep4Mri(masters: any) {
        const columns: any[] = [];
        const columns2: any[] = [];

        columns.push(this.getCommonFieldProps(Enums.ProaBasicFields.PProaMRIPriority, masters));
        columns.push(this.getCommonFieldProps(Enums.ProaBasicFields.PProaDescripcion, masters));
        columns.push(this.getCommonFieldProps(Enums.ProaBasicFields.PProaUnidadMedida, masters));
        columns.push(this.getCommonFieldProps(Enums.ProaBasicFields.LineaBase, masters));
        columns.push(this.getCommonFieldProps(Enums.ProaBasicFields.PProaAnioLineaBase, masters));
        columns.push(this.getCommonFieldProps(Enums.ProaBasicFields.PProaMetaMRI, masters));
        columns.push(this.getDeleteColumn("Step4Mri"))

        let metaYear = this.getCommonFieldProps(Enums.ProaBasicFields.Meta, masters);
        metaYear.fieldType = Enums.FieldTypes.Text
        metaYear.title = this.currentLabels.get("Anio")
        columns2.push(metaYear)
        columns2.push(this.getCommonFieldProps(Enums.ProaBasicFields.Meta, masters, true));
        columns2.push(this.getDeleteColumn("Step4Mri", true))
        this.getDataSourceStepMri(masters) 

        return {auxCol: columns, auxYearCol: columns2}
    }

    public getDataColumnsPpalObj(masters: any) {
        const columns: any[] = [];

        columns.push(this.getCommonFieldProps(Enums.ProaBasicFields.ObjetivoEspecifico, masters));
        columns.push(this.getDeleteColumn("Step4Obj"))
        
        return columns
    }

    public getDataColumnsPpalRes(masters: any) {
        const columns: any[] = [];

        columns.push(this.getCommonFieldProps(Enums.ProaBasicFields.PProaResultadoEsperado, masters));
        columns.push(this.getDeleteColumn("Step4Res"))
        
        return columns
    }

    public getDataColumnsStep4Obj(masters: any) {
        const columns: any[] = [];
        const columns2: any[] = [];

        columns.push(this.getCommonFieldProps(Enums.ProaBasicFields.PProaIndicadorObjetivo, masters));
        columns.push(this.getCommonFieldProps(Enums.ProaBasicFields.PProaMedidaId, masters));
        columns.push(this.getCommonFieldProps(Enums.ProaBasicFields.LineaBase, masters));
        columns.push(this.getCommonFieldProps(Enums.ProaBasicFields.PProaAnioLineaBase, masters));
        columns.push(this.getCommonFieldProps(Enums.ProaBasicFields.PProaMetaFinanciera, masters));
        columns.push(this.getDeleteColumn("Step4ObjInd"))

        let metaYear = this.getCommonFieldProps(Enums.ProaBasicFields.Meta, masters);
        metaYear.fieldType = Enums.FieldTypes.Text
        metaYear.title = this.currentLabels.get("Anio")
        columns2.push(metaYear)
        columns2.push(this.getCommonFieldProps(Enums.ProaBasicFields.Meta, masters, true));
        columns2.push(this.getDeleteColumn("Step4ObjInd", true))
        this.getDataSourceStepObj() 

        return {auxCol: columns, auxYearCol: columns2}
    }

    public getDataColumnsStep4Res(masters: any) {
        const columns: any[] = [];
        const columns2: any[] = [];
        columns.push(this.getCommonFieldProps(Enums.ProaBasicFields.PProaIndicadorResultadoEsperado, masters));
        columns.push(this.getCommonFieldProps(Enums.ProaBasicFields.PProaMedidaId, masters));
        columns.push(this.getCommonFieldProps(Enums.ProaBasicFields.LineaBase, masters));
        columns.push(this.getCommonFieldProps(Enums.ProaBasicFields.PProaAnioLineaBase, masters));
        columns.push(this.getCommonFieldProps(Enums.ProaBasicFields.PProaMetaFinanciera, masters));
        columns.push(this.getDeleteColumn("Step4ResInd"))

        let metaYear = this.getCommonFieldProps(Enums.ProaBasicFields.Meta, masters);
        metaYear.fieldType = Enums.FieldTypes.Text
        metaYear.title = this.currentLabels.get("Anio")
        columns2.push(metaYear)
        columns2.push(this.getCommonFieldProps(Enums.ProaBasicFields.Meta, masters, true));
        columns2.push(this.getDeleteColumn("Step4ResInd", true))
        this.getDataSourceStepRes() 

        return {auxCol: columns, auxYearCol: columns2}
    }
    public getDataColumnsStep4Act(masters: any) {
        const columns: any[] = [];
        const columns2: any[] = [];
        let PProaValorActividad = this.getCommonFieldProps(Enums.ProaBasicFields.PProaValorActividad, masters);
        PProaValorActividad.fieldType = Enums.FieldTypes.currency;
        PProaValorActividad.title = this.currentLabels.get('PresupuestoTotal');
        PProaValorActividad.description = this.currentLabels.get('PresupuestoTotal');

        columns.push(this.getCommonFieldProps(Enums.ProaBasicFields.PProaActividad, masters));
        columns.push(this.getCommonFieldProps(Enums.ProaBasicFields.PProaMedidaId, masters));
        columns.push(this.getCommonFieldProps(Enums.ProaBasicFields.MetaTotalProyecto, masters));
        columns.push(PProaValorActividad);
        columns.push(this.getDeleteColumn("Step4Act"))
        
        let metaYear = this.getCommonFieldProps(Enums.ProaBasicFields.Meta, masters);
        metaYear.fieldType = Enums.FieldTypes.Text
        metaYear.title = this.currentLabels.get("Anio")
        columns2.push(metaYear)
        columns2.push(this.getCommonFieldProps(Enums.ProaBasicFields.SubTotal, masters));
        let budgetYear = this.getCommonFieldProps(Enums.ProaBasicFields.Meta, masters, true);
        budgetYear.title = this.currentLabels.get('Presupuesto');
        columns2.push(budgetYear)
        columns2.push(this.getDeleteColumn("Step4Act", true))
        this.getDataSourceStepAct() 

        return {auxCol: columns, auxYearCol: columns2}
    }

    public getIndType1Columns(masters: any, section: string){
        this.getIndType1Data(masters, section)
        return [
            this.getCommonFieldProps2("indicator", masters),
            this.getCommonFieldProps2("baseLine", masters),
            this.getCommonFieldProps2("criteria", masters),
            this.getCommonFieldProps2("frecuency", masters),
            this.getCommonFieldProps2("plannedGoal", masters),
            this.getCommonFieldProps2("plannedGoalMod", masters),
            this.getCommonFieldProps2("endGoal", masters),
            this.getCommonFieldProps2("endGoalMod", masters),
            this.getCommonFieldProps2("achievedGoal", masters), 
            this.getCommonFieldProps2("actualAchievedGoal", masters), 
            this.getCommonFieldProps2("currentProgressPercent", masters),
            this.getCommonFieldProps2("totalProgressPercent", masters),
        ]

        
    }

    public getIndType2Columns(masters: any, section: string){
        this.getIndType2Data(masters, section)
        return [
            this.getCommonFieldProps2("selected", masters),
            this.getCommonFieldProps2("indicator", masters),
            this.getCommonFieldProps2("lbUnity", masters),
            this.getCommonFieldProps2("frecuency", masters),
            this.getCommonFieldProps2("plannedGoal", masters),
            this.getCommonFieldProps2("achievedGoal", masters),
            this.getCommonFieldProps2("plannedAchievement", masters),
            this.getCommonFieldProps2("plannedGoalMod", masters),
            this.getCommonFieldProps2("plannedAchievementMod", masters),
            this.getCommonFieldProps2("endGoal", masters),
            this.getCommonFieldProps2("endGoalMod", masters), 
            this.getCommonFieldProps2("totalMonthPl", masters),
            this.getCommonFieldProps2("currentAchievementAch", masters),
            this.getCommonFieldProps2("actualActAchievedGoal", masters),
            this.getCommonFieldProps2("totalAchievement", masters),
            this.getCommonFieldProps2("currentProgressPercent", masters),
            this.getCommonFieldProps2("totalProgressPercent", masters),
        ]
    }

    public getMonthsDetailsColumns(masters: any){
        return [
            this.getCommonFieldProps2("january", masters),
            this.getCommonFieldProps2("february", masters),
            this.getCommonFieldProps2("march", masters),
            this.getCommonFieldProps2("april", masters),
            this.getCommonFieldProps2("may", masters),
            this.getCommonFieldProps2("june", masters),
            this.getCommonFieldProps2("july", masters),
            this.getCommonFieldProps2("august", masters),
            this.getCommonFieldProps2("september", masters),
            this.getCommonFieldProps2("october", masters),
            this.getCommonFieldProps2("november", masters),
            this.getCommonFieldProps2("december", masters),
        ]
    }

    public getBeneficiariesData(masters: any, section: string){
        let data = this.view.state.data
        let monthsSp = Constants.Months.Spanish
        let monthsEn = Constants.Months.English
        
        let result: any[] = []
        
            data?.forEach((x:any) => {
                if(section === "bySubProject"){
                    let findYear = this.view.state.stepsData.step1?.beneficiaries?.find((y: any) => y.Id === x.SPCBeneficiariosAniosId)
                    let infoByAct: any = {
                        idYear: findYear?.Id,
                        description: "Beneficiarios",
                        planningMen: findYear?.PFFRRTotalHombres,
                        planningWomen: findYear?.PFRRTotalMujeres,
                        planningTotal: findYear?.PPresTotalAnio,
            
                        menMod: x?.TotalHombresModificado,
                        womenMod: x?.TotalMujeresModificado,
                        totalMod: x?.TotalBeneficiarios,
                        totalModNv: x?.TotalBeneficiarios,
                        relatedId: x?.Id
                    }
                    
                    result.push(infoByAct)
                }else if(section === "byLocation"){
                    let step = this.view.state.stepsData.step3?.find((z: any) => z.genericInfo?.PProaLocationId === x.PProaLocationId)?.genericInfo
                    let infoByAct = {
                        fieldDescriptionId: step.PProaLocation.Id,
                        fieldDescription: step.PProaLocation?.Title || '',
                        fieldMen: x?.PFFRRTotalHombres,
                        fieldWomen: x?.PFRRTotalMujeres,
                        fieldTotal: x?.PFFRRTotal,
                        relatedId: x?.Id,
                    }
                    
                    result.push(infoByAct)
                }else if(section === "byActivity"){
                    let stepData: any = null, plannedGoal: any = null
                    this.view.state.stepsData.step4.objetives?.forEach((element: any) => {
                        element.results?.forEach((element2: any) => {
                            if(!stepData){
                                stepData = element2.activities?.find((y: any) => y.genericInfo?.Id === x.IndicadorActividadId)
                                plannedGoal = stepData?.years?.find((y: any) => y.Id === x.IndicadorActividadAnioId)
                            }
                        });
                    });
    
                    let auxAct: any = {
                        idYear: plannedGoal?.Id,
                        idParent: stepData?.genericInfo?.Id, 
                        activity: stepData?.genericInfo?.PProaActividad,
                        relatedId: x?.Id,
                        toSave: true,
    
                        beneficiariesByActivity: x?.BeneficiariosPlan,
                        achievedBeneficiaries: x?.BeneficiariosAlcanzados,
                        accumBeneficiaries: x?.BeneficiariosAcumulados,
                        activityPercentage: x?.PorcentajeAvancePorActividad,
                    }
                    monthsSp?.forEach((month: string, i: number) => {
                        auxAct[monthsEn[i] + 'Pl'] = x?.[month + 'Plan'] ?? null
                        auxAct[monthsEn[i] + 'Re'] = x?.[month + 'Real'] ?? null
                    });
                    result.push(auxAct)
                }else if(section === "byOverlaps"){
                    let stepData: any = null, plannedGoal: any = null
                            this.view.state.stepsData.step4.objetives?.forEach((element: any) => {
                                if(!stepData){
                                    stepData = element.results?.find((y: any) => y.genericInfo?.Id === x.PProaFEStep4ResultadosEsperadosId)
                                }
                            });
                    let resOver: any = {
                        beneficiariesByResult: x?.BeneficiariosPlan,
                        id: stepData?.genericInfo?.Id,
                        idParent: stepData?.genericInfo?.PProaFEStep4Id,
                        result: stepData?.genericInfo?.PProaResultadoEsperado,
                        achievedBeneficiaries: x?.BeneficiariosAlcanzados,
                        accumBeneficiaries: x?.BeneficiariosAcumulados,
                        activityPercentage: x?.PorcentajeAvancePorActividad,
                    }
                    monthsSp?.forEach((month: string, i: number) => {
                        resOver[monthsEn[i] + 'Pl'] = x?.[month + 'Plan'] ?? null
                        resOver[monthsEn[i] + 'Re'] = x?.[month + 'Real'] ?? null
                    });
                    result.push(resOver)
                }
            })
        
        this.view.state.setDataSource(result)
    }
    
    public getFinancialData(masters: any, section: string){
        let data = this.view.state.data
        let monthsSp = Constants.Months.Spanish
        let monthsEn = Constants.Months.English
        
        let result: any[] = []
        data?.forEach((x:any) => {
            if(section === "implementer"){
                let step = this.view.state.stepsData.step2?.find((z: any) => z.genericInfo?.Id === x.PProaFRStep2Id)
                let impYear = step.years?.find((a: any) => a.Id === x.PProaFRStep2AniosId)

                let auxImp: any = {
                    id: step.genericInfo?.Id,
                    idYear: impYear.Id,
                    idParent: 1,
                    implementer: masters.slep?.find((y: any) => y.Id === step.genericInfo?.OCTAVIASLEPId)?.Title || '',
                    relatedId: x?.Id,

                    currentBudget: impYear?.PProaAnioValue,
                    currentBudgetMod: x?.PresupuestoAnioMod,
                    executedBudget: x?.PProaEjecutadoAnio,
                    accumBudgetExecuted: x?.PProaAcumuladoProyecto,
                    yearPercentage: x?.AvanceEjecucionAnio,
                }
                monthsSp?.forEach((month: string, i: number) => {
                    auxImp[monthsEn[i] + 'Pl'] = x?.[month + 'Plan'] ?? null
                    auxImp[monthsEn[i] + 'Re'] = x?.[month + 'Real'] ?? null
                });
                result.push(auxImp)
            }else if(section === "location"){
                let step = this.view.state.stepsData.step3?.find((z: any) => z.genericInfo?.Id === x.PProaFRStep3Id)
                let locYear = step.years?.find((a: any) => a.Id === x.PProaFRStep3AniosId)
                let auxLoc: any = {
                    id: step.genericInfo?.Id,
                    idYear: locYear.Id,
                    idParent: 1,
                    location: step.genericInfo?.PProaLocation?.Title || '',
                    relatedId: x?.Id,
    
                    currentBudget: locYear?.PProaAnioValue,
                    currentBudgetMod: x?.PresupuestoAnioMod,
                    executedBudget: x?.PProaEjecutadoAnio,
                    accumBudgetExecuted: x?.PProaAcumuladoProyecto,
                    yearPercentage: x?.AvanceEjecucionAnio,
                }
                monthsSp?.forEach((month: string, i: number) => {
                    auxLoc[monthsEn[i] + 'Pl'] = x?.[month + 'Plan'] ?? null
                    auxLoc[monthsEn[i] + 'Re'] = x?.[month + 'Real'] ?? null
                });
                
                result.push(auxLoc)
            }else if(section === "adt"){
                let step = this.view.state.stepsData.step3?.find((z: any) => z.genericInfo?.Id === x.PProaFRStep3Id)
                let locYear = step.years?.find((a: any) => a.Id === x.PProaFRStep3AniosId)
                let auxLoc: any = {
                    id: step.genericInfo?.Id,
                    idYear: locYear.Id,
                    idParent: 1,
                    adt: step.genericInfo?.PProaAdt?.Title || '',
                    relatedId: x?.Id,
    
                    currentBudget: locYear?.PProaAnioValue,
                    currentBudgetMod: x?.PresupuestoAnioMod,
                    executedBudget: x?.PProaEjecutadoAnio,
                    accumBudgetExecuted: x?.PProaAcumuladoProyecto,
                    yearPercentage: x?.AvanceEjecucionAnio,
                }
                monthsSp?.forEach((month: string, i: number) => {
                    auxLoc[monthsEn[i] + 'Pl'] = x?.[month + 'Plan'] ?? null
                    auxLoc[monthsEn[i] + 'Re'] = x?.[month + 'Real'] ?? null
                });
                
                result.push(auxLoc)
            }else if(section === "sdc"){
                let step = this.view.state.stepsData.stepSDC?.find((z: any) => z.genericInfo?.Id === x.PProaContrapartidaId)
                let locYear = step.years?.find((a: any) => a.Id === x.PProaContrapartidaAnioId)
                let counterpartType = masters.counterpartType?.find((y: any) => y.Id === step.genericInfo?.PProaTipoContrapartidaId)?.Title
                let counterpart = (!!step.genericInfo?.OCTAVIACodigoFinanciacionId) ? masters.grantCodes?.find((x: any) => x.Id === step.genericInfo?.OCTAVIACodigoFinanciacionId)?.Title 
                    : (!!step.genericInfo?.OCTAVIAFinanciadorSapId) ? masters.allFinancers?.find((x: any) => x.Id === step.genericInfo?.OCTAVIAFinanciadorSapId)?.Title
                    : (!!step.genericInfo?.OCTAVIASLEPId) ? masters.slep?.find((y: any) => y.Id === step.genericInfo?.OCTAVIASLEPId)?.Title : step.genericInfo?.Title

                let auxLoc: any = {
                    id: step.genericInfo?.Id,
                    idYear: locYear.Id,
                    idParent: 1,
                    sdc: counterpartType || '',
                    counterpart: counterpart || '',
                    relatedId: x?.Id,
    
                    currentBudget: locYear?.PProaAnioValue,
                    currentBudgetMod: x?.PresupuestoAnioMod,
                    executedBudget: x?.PProaEjecutadoAnio,
                    accumBudgetExecuted: x?.PProaAcumuladoProyecto,
                    yearPercentage: x?.AvanceEjecucionAnio,
                }
                monthsSp?.forEach((month: string, i: number) => {
                    auxLoc[monthsEn[i] + 'Pl'] = x?.[month + 'Plan'] ?? null
                    auxLoc[monthsEn[i] + 'Re'] = x?.[month + 'Real'] ?? null
                });
                
                result.push(auxLoc)
            }else if(section === "activity"){
                let stepData: any = null, plannedGoal: any = null
                this.view.state.stepsData.step4.objetives?.forEach((element: any) => {
                    element.results?.forEach((element2: any) => {
                        if(!stepData){
                            stepData = element2.activities?.find((y: any) => y.genericInfo?.Id === x.IndicadorActividadId)
                            plannedGoal = stepData?.years?.find((y: any) => y.Id === x.IndicadorActividadAnioId)
                        }
                    });
                });

                let auxAct: any = {
                    id: stepData?.genericInfo?.Id,
                    idYear: plannedGoal?.Id,
                    activity: stepData?.genericInfo?.PProaActividad,
                    relatedId: x?.Id,

                    currentBudget: plannedGoal?.PProaAnioValue,
                    currentBudgetMod: x?.PresupuestoAnioMod ?? null,
                    totalBudget: stepData?.genericInfo?.PProaValorActividad,
                    totalBudgetMod: x?.PresupuestoTotalAnioMod ?? null,
                    projectPercentage: x?.AvanceEjecucionProyecto,
                    executedBudget: x?.PProaEjecutadoAnio,
                    accumBudgetExecuted: x?.PProaAcumuladoProyecto,
                    yearPercentage: x?.AvanceEjecucionAnio,
                }
                monthsSp?.forEach((month: string, i: number) => {
                    auxAct[monthsEn[i] + 'Pl'] = x?.[month + 'Plan'] ?? null
                    auxAct[monthsEn[i] + 'Re'] = x?.[month + 'Real'] ?? null
                });
                result.push(auxAct)
            }else if(section === "totalResults"){
                let stepData: any = null, plannedGoal: any = null, currentBudget = 0, totalBudget = 0
                this.view.state.stepsData.step4.objetives?.forEach((element: any) => {
                    if(!stepData){
                        stepData = element.results?.find((y: any) => y.genericInfo?.Id === x.PProaFEStep4ResultadosEsperadosId)
                        stepData?.activities?.forEach((act: any) => {
                            let year = act.years?.find((z: any) => z.PPresAnioMeta === Number(x.Title))
                            currentBudget += year?.PProaAnioValue || 0
                            totalBudget += act.genericInfo?.PProaValorActividad || 0
                        });
                        
                    }
                    
                });

                let auxAct: any = {
                    id: stepData?.genericInfo?.Id,
                    result: stepData?.genericInfo?.PProaResultadoEsperado,
                    relatedId: x?.Id,

                    currentBudget: currentBudget,
                    currentBudgetMod: x?.PresupuestoAnioMod ?? null,
                    totalBudget: totalBudget,
                    totalBudgetMod: x?.PresupuestoTotalAnioMod ?? null,
                    projectPercentage: x?.AvanceEjecucionProyecto,
                    executedBudget: x?.PProaEjecutadoAnio,
                    accumBudgetExecuted: x?.PProaAcumuladoProyecto,
                    yearPercentage: x?.AvanceEjecucionAnio,
                }
                monthsSp?.forEach((month: string, i: number) => {
                    auxAct[monthsEn[i] + 'Pl'] = x?.[month + 'Plan'] ?? null
                    auxAct[monthsEn[i] + 'Re'] = x?.[month + 'Real'] ?? null
                });
                result.push(auxAct)
            }
        });
        this.view.state.setDataSource(result)
    }

    public getFinancialColumns(masters: any, section: string){

        let baseColumns = [
            this.getCommonFieldProps2("currentBudget", masters),
            this.getCommonFieldProps2("currentBudgetMod", masters),
            ...this.getMonthsDetailsColumns(masters),
            this.getCommonFieldProps2("totalMonthPl", masters),
            this.getCommonFieldProps2("executedBudget", masters),
            this.getCommonFieldProps2("accumBudgetExecuted", masters),
            this.getCommonFieldProps2("yearPercentage", masters),
        ]

        this.getFinancialData(masters, section)

        switch (section) {
            case 'resume':
                return [
                    this.getCommonFieldProps2("budgetType", masters),
                    this.getCommonFieldProps2("yearBudget", masters),
                    this.getCommonFieldProps2("yearBudgetMod", masters),
                    this.getCommonFieldProps2("yearBudgetExecuted", masters)
                ]
            case 'activity':
                return [
                    this.getCommonFieldProps2("activity", masters),
                    this.getCommonFieldProps2("currentBudget", masters),
                    this.getCommonFieldProps2("currentBudgetMod", masters),
                    this.getCommonFieldProps2("totalBudget", masters),
                    this.getCommonFieldProps2("totalBudgetMod", masters),
                    ...this.getMonthsDetailsColumns(masters),
                    this.getCommonFieldProps2("totalMonthPl", masters),
                    this.getCommonFieldProps2("executedBudget", masters),
                    this.getCommonFieldProps2("accumBudgetExecuted", masters),
                    this.getCommonFieldProps2("yearPercentage", masters),
                    this.getCommonFieldProps2("projectPercentage", masters),
                ]
            case 'totalResults':
                return [
                    this.getCommonFieldProps2("result", masters),
                    this.getCommonFieldProps2("currentBudget", masters),
                    this.getCommonFieldProps2("currentBudgetMod", masters),
                    this.getCommonFieldProps2("totalBudget", masters),
                    this.getCommonFieldProps2("totalBudgetMod", masters),
                    ...this.getMonthsDetailsColumns(masters),
                    this.getCommonFieldProps2("totalMonthPl", masters),
                    this.getCommonFieldProps2("executedBudget", masters),
                    this.getCommonFieldProps2("accumBudgetExecuted", masters),
                    this.getCommonFieldProps2("yearPercentage", masters),
                    this.getCommonFieldProps2("projectPercentage", masters),
                ]
            case 'implementer':
                return [
                    this.getCommonFieldProps2("implementer", masters),
                    ...baseColumns
                ]
            case 'location':
                return [
                    this.getCommonFieldProps2("location", masters),
                    ...baseColumns
                ]
            case 'adt':
                return [
                    this.getCommonFieldProps2("adt", masters),
                    ...baseColumns
                ]
            case 'sdc':
                return [
                    this.getCommonFieldProps2("sdc", masters),
                    this.getCommonFieldProps2("counterpart", masters),
                    ...baseColumns
                ]
            default:
                return baseColumns
        }
    }

    public getBeneficiariesColumns(masters: string, section: string){
        this.getBeneficiariesData(masters, section)
        switch (section) {
            case 'bySubProject':
                return [
                    this.getCommonFieldProps2("description", masters),
                    this.getCommonFieldProps2("men", masters),
                    this.getCommonFieldProps2("women", masters),
                    this.getCommonFieldProps2("total", masters)
                ]
            case 'byLocation':
                return [
                    this.getCommonFieldProps2("fieldDescription", masters),
                    this.getCommonFieldProps2("fieldMen", masters),
                    this.getCommonFieldProps2("fieldWomen", masters),
                    this.getCommonFieldProps2("fieldTotal", masters),
                ]
            case 'byActivity':
                return [
                    this.getCommonFieldProps2("activity", masters),
                    this.getCommonFieldProps2("beneficiariesByActivity", masters),
                    ...this.getMonthsDetailsColumns(masters),
                    this.getCommonFieldProps2("totalMonthPl", masters),
                    this.getCommonFieldProps2("achievedBeneficiaries", masters),
                    this.getCommonFieldProps2("accumBeneficiaries", masters),
                    this.getCommonFieldProps2("activityPercentage", masters),
                ]
            case 'byOverlaps':
                return [
                    this.getCommonFieldProps2("result", masters),
                    this.getCommonFieldProps2("beneficiariesByResult", masters),
                    ...this.getMonthsDetailsColumns(masters),
                    this.getCommonFieldProps2("totalMonthPl", masters),
                ]
        }
    }

    public getIndType1Data(masters: any, section: string){
        let data = this.view.state.data
        
        let result: any[] = []
        data?.forEach((x:any) => {
            let stepData: any = null, strategicLine: any = null, measureUnits: any = null, plannedGoal: any = null 
            if(section === "results"){
                this.view.state.stepsData.step4.objetives?.forEach((element: any) => {
                    element.results?.forEach((element2: any) => {
                        if(!stepData){
                            stepData = element2.details?.find((y: any) => y.genericInfo?.Id === x.IndicadorResultadoEsperadoId)
                            plannedGoal = stepData?.years?.find((y: any) => y.Id === x.IndicadorResultadoEsperadoAnioId)
                        }
                    });
                });

                measureUnits = masters.measureUnits?.find((y: any) => y.Id === stepData?.genericInfo?.PProaMedidaId)?.Title ?? null

                let auxRes: any = {
                    indicator: stepData?.genericInfo?.PProaIndicadorResultadoEsperado,
                    lbValue: stepData?.genericInfo?.PFFRRLineaBase,
                    lbUnity: measureUnits,
                    lbAnio: stepData?.genericInfo?.PProaAnioLineaBase,
                    plannedGoal: plannedGoal?.PProaAnioValue,
                    endGoal: stepData?.genericInfo?.PProaMetaFinanciera,
                    currentProgressPercent: 0,
                    totalProgressPercent: 0,
                    idYear: plannedGoal?.Id,
                    
                    criteria: x?.CriterioExitoId,
                    frecuency: x?.FrecuenciaMedicionId,
                    relatedId: x?.Id,

                    plannedGoalMod: x?.MetaPlaneadaAnioMod,
                    endGoalMod: x?.MetaFinalProyectoMod,
                    actualAchievedGoal: x?.MetaAlcanzada,
                    plannedGoalModNv: x?.MetaPlaneadaAnioMod,
                    endGoalModNv: x?.MetaFinalProyectoMod,
                    actualAchievedGoalNv: x?.MetaAlcanzada,
                    achievedGoal: x?.MetaAlcanzada,
                    achievedGoalAnt: x?.MetaAlcanzadaAnioAnterior
                }
                result.push(auxRes)
            }else if(section === "objetives"){
                this.view.state.stepsData.step4.objetives?.forEach((element: any) => {
                    if(!stepData){
                        stepData = element.specificObjetives?.find((y: any) => y.genericInfo?.Id === x.IndicadorObjetivoId)
                        plannedGoal = stepData?.years?.find((y: any) => y.Id === x.IndicadorObjetivoAnioId)
                    }
                });

                measureUnits = masters.measureUnits?.find((y: any) => y.Id === stepData?.genericInfo?.PProaMedidaId)?.Title ?? null

                let auxObj: any = {
                    id: stepData?.genericInfo?.Id,
                    indicator: stepData?.genericInfo?.PProaIndicadorObjetivo,
                    lbValue: stepData?.genericInfo?.PFFRRLineaBase,
                    lbUnity: measureUnits,
                    lbAnio: stepData?.genericInfo?.PProaAnioLineaBase,
                    plannedGoal: plannedGoal?.PProaAnioValue,
                    endGoal: stepData?.genericInfo?.PProaMetaFinanciera,
                    currentProgressPercent: 0,
                    totalProgressPercent: 0,
                    idYear: plannedGoal?.Id,

                    criteria: x?.CriterioExitoId,
                    frecuency: x?.FrecuenciaMedicionId,
                    relatedId: x?.Id,

                    plannedGoalMod: x?.MetaPlaneadaAnioMod,
                    endGoalMod: x?.MetaFinalProyectoMod,
                    actualAchievedGoal: x?.MetaAlcanzada,
                    plannedGoalModNv: x?.MetaPlaneadaAnioMod,
                    endGoalModNv: x?.MetaFinalProyectoMod,
                    actualAchievedGoalNv: x?.MetaAlcanzada,
                    achievedGoal: x?.MetaAlcanzada,
                    achievedGoalAnt: x?.MetaAlcanzadaAnioAnterior
                }
                result.push(auxObj)
            }else{
                if(section === "secondIndicator"){
                    stepData = this.view.state.stepsData.step4.mri?.find((z: any) => z.genericInfo?.Id === x.IndicadorLineaEstrategicaSecundaId)
                    plannedGoal = stepData?.years?.find((a: any) => a.Id === x.IndLineaEstrategicaAniosSecundarId)
                    strategicLine = masters.strategicLine?.find((c: any) => c.Id === Number(x?.PPresIndicadorLineaEstrategicaId))
                    measureUnits = (!!strategicLine) ? masters.measureUnits?.find((v: any) => v.Id === Number(strategicLine?.PMedidaId)) : null
                    stepData = stepData?.genericInfo
    
                }else if(section === "resultsIndicators"){
                    stepData = this.view.state.stepsData.step4.mri?.find((z: any) => z.genericInfo?.Id === x.IndicadorInstitucionalResultadosId)
                    plannedGoal = stepData?.years?.find((a: any) => a.Id === x.IndicadorInstitucionalResultados0Id)
                    strategicLine = masters.intermediateIndicatorResults?.find((c: any) => c.Id === Number(x?.PFFRRIndicadorResultadoIntermediId?.[0]))
                    measureUnits = (!!strategicLine) ? masters.measureUnits?.find((v: any) => v.Id === Number(strategicLine?.PMedidaId)) : null
                    stepData = stepData?.genericInfo
    
                }else{
                    stepData = this.view.state.stepsData.step1.genericInfo
                    strategicLine = masters.strategicLine?.find((y: any) => y.Id === Number(stepData?.PPresIndicadorLineaEstrategica1Id))
                    measureUnits = (!!strategicLine) ? masters.measureUnits?.find((z: any) => z.Id === Number(strategicLine?.PMedidaId)) : null
                    plannedGoal = this.view.state.stepsData.step1.years?.find((z: any) => z.Id === x.IndicadorLineaEstrategicaAniosId)
                }
    
                let auxInd: any = {
                    id: stepData?.Id,
                    indicator: strategicLine?.Title,
                    lbValue: stepData?.PFFRRLineaBase,
                    lbUnity: measureUnits?.Title,
                    lbAnio: stepData?.PProaAnioLineaBase,
                    plannedGoal: plannedGoal?.PProaAnioValue,
                    endGoal: stepData?.PProaMetaFinal ?? stepData?.PProaMetaMRI,
                    currentProgressPercent: x.PorcentajeAvanceAnio,
                    totalProgressPercent: x.PorcentajeAvanceTotalProyecto,
                    idYear: plannedGoal?.Id,
    
                    criteria: x?.CriterioExitoId,
                    frecuency: x?.FrecuenciaMedicionId,
                    relatedId: x?.Id,
    
                    plannedGoalMod: x?.MetaPlaneadaAnioMod,
                    endGoalMod: x?.MetaFinalProyectoMod,
                    actualAchievedGoal: x?.MetaAlcanzada,
                    plannedGoalModNv: x?.MetaPlaneadaAnioMod,
                    endGoalModNv: x?.MetaFinalProyectoMod,
                    actualAchievedGoalNv: x?.MetaAlcanzada,
                    achievedGoal: x?.MetaAlcanzada,
                    achievedGoalAnt: x?.MetaAlcanzadaAnioAnterior
                };
                result.push(auxInd)

            }

            
        });
        this.view.state.setDataSource(result)
    }

    public getIndType2Data(masters: any, section: string){
        let data = this.view.state.data
        let monthsSp = Constants.Months.Spanish
        let monthsEn = Constants.Months.English

        let result: any[] = []
        data?.forEach((x:any) => {
            let stepData: any = null, strategicLine: any = null, measureUnits: any = null, plannedGoal: any = null 

            if(section === "productsIndicators"){
                stepData = this.view.state.stepsData.step4.mri?.find((z: any) => z.genericInfo?.Id === x.IndicadorInstitucionalProductosId)
                plannedGoal = stepData?.years?.find((a: any) => a.Id === x.IndicadorInstitucionalProductosAId)
                strategicLine = masters.productsIndicator?.find((c: any) => c.Id === Number(x?.PFFRRIndicadorProductoId))
                measureUnits = (!!strategicLine) ? masters.measureUnits?.find((v: any) => v.Id === Number(strategicLine?.PMedidaId)) : null
                stepData = stepData?.genericInfo
            
                let auxInd: any = {
                    id: stepData?.Id,
                    indicator: strategicLine?.Title,
                    lbValue: stepData?.PFFRRLineaBase,
                    lbUnity: measureUnits?.Title,
                    lbAnio: stepData?.PProaAnioLineaBase,
                    plannedGoal: plannedGoal?.PProaAnioValue,
                    endGoal: stepData?.PProaMetaMRI,
                    currentProgressPercent: x?.PorcentajeAvanceAnio,
                    totalProgressPercent: x?.PorcentajeAvanceTotalProyecto,
                    idYear: plannedGoal?.Id,

                    criteria: x?.CriterioExitoId,
                    frecuency: x?.FrecuenciaMedicionId,
                    relatedId: x?.Id,

                    plannedGoalMod: x?.MetaPlaneadaAnioMod,
                    endGoalMod: x?.MetaFinalProyectoMod,
                    actualAchievedGoal: x?.MetaAlcanzada,
                    plannedGoalModNv: x?.MetaPlaneadaAnioMod,
                    endGoalModNv: x?.MetaFinalProyectoMod,
                    actualAchievedGoalNv: x?.MetaAlcanzada,
                    achievedGoalAnt: x?.MetaAlcanzadaAnioAnterior,
                    actualActAchievedGoal: x?.MetaAlcanzada,
                    plannedAchievement: x?.LogroPlaneadoAnio,
                    plannedAchievementMod: x?.LogroPlaneadoAnioMod,
                    currentAchievementAch: x?.LogroAlcanzadoAnio,
                    totalAchievement: x?.LogroAcumuladoProyecto
                };

                monthsSp?.forEach((month: string, i: number) => {
                    auxInd[monthsEn[i] + 'Pl'] = x?.[month + 'Plan'] ?? null
                    auxInd[monthsEn[i] + 'Re'] = x?.[month + 'Real'] ?? null
                });
                result.push(auxInd)
            }else if(section === "activities"){
                
                this.view.state.stepsData.step4.objetives?.forEach((element: any) => {
                    element.results?.forEach((element2: any) => {
                        if(!stepData){
                            stepData = element2.activities?.find((y: any) => y.genericInfo?.Id === x.IndicadorActividadId)
                            plannedGoal = stepData?.years?.find((y: any) => y.Id === x.IndicadorActividadAnioId)
                        }
                    });
                });

                measureUnits = masters.measureUnits?.find((y: any) => y.Id === stepData?.genericInfo?.PProaMedidaId)?.Title ?? null

                let auxAct: any = {
                    indicator: stepData?.genericInfo?.PProaActividad,
                    lbUnity: measureUnits,
                    plannedGoal: plannedGoal?.PFFRRSubTotal,
                    endGoal: stepData?.genericInfo?.PProaMetaTotalProyecto,
                    currentProgressPercent: 0,
                    totalProgressPercent: 0,
                    idYear: plannedGoal?.Id,
                    
                    frecuency: x?.FrecuenciaMedicionId ?? null,
                    plannedGoalMod: x?.MetaPlaneadaAnioMod,
                    endGoalMod: x?.MetaFinalProyectoMod,
                    actualAchievedGoal: x?.MetaAlcanzada,
                    plannedGoalModNv: x?.MetaPlaneadaAnioMod,
                    endGoalModNv: x?.MetaFinalProyectoMod,
                    actualAchievedGoalNv: x?.MetaAlcanzada,
                    achievedGoalAnt: x?.MetaAlcanzadaAnioAnterior,
                    actualActAchievedGoal: x?.MetaAlcanzada,
                    plannedAchievement: x?.LogroPlaneadoAnio,
                    plannedAchievementMod: x?.LogroPlaneadoAnioMod,
                    currentAchievementAch: x?.LogroAlcanzadoAnio,
                    totalAchievement: x?.LogroAcumuladoProyecto
                }

                monthsSp?.forEach((month: string, i: number) => {
                    auxAct[monthsEn[i] + 'Pl'] = x?.[month + 'Plan'] ?? null
                    auxAct[monthsEn[i] + 'Re'] = x?.[month + 'Real'] ?? null
                });
                result.push(auxAct)
            }
        });
        this.view.state.setDataSource(result)
    }

    private getCommonFieldProps2(fieldName: string, masters: any) {
        const fieldProps = this.view.state.columns.get(fieldName);
        const year = this.view.state.year ? Number(this.view.state.year) : this.view.state.year;

        const field: any = {
            id: `${fieldProps?.Id || 0}_followup`,
            caption: fieldProps?.OCTAVIAValorTraduccion || "",
            dataField: fieldProps?.Title || "",
            dataType: fieldProps?.OCTAVIATipoCampo || "string",
            allowEditing: !fieldProps?.SoloLectura,
            alignment: fieldProps?.Alineacion || "center",
            format: fieldProps?.Format || "",
            width: 150,
        };

        if(!!fieldProps.OCTAVIALista){
            field.lookup = { 
                dataSource: masters[fieldProps.OCTAVIALista], displayExpr: "Title", valueExpr: "Id" 
            }
        }
        if(fieldName === Enums.FollowupBasicFields.achievedGoal){
            field.caption += ` ${(year -1)}`
            field.dataField += `Ant`  
        }
        if(fieldName === Enums.FollowupBasicFields.actualAchievedGoal || fieldName === Enums.FollowupBasicFields.actualActAchievedGoal ||
            fieldName === Enums.FollowupBasicFields.plannedAchievement || fieldName === Enums.FollowupBasicFields.plannedAchievementMod ||
            fieldName === Enums.FollowupBasicFields.currentAchievementAch){
            field.caption += ` ${year}`
        }
        if(fieldName === Enums.FollowupBasicFields.men){
            field.columns = [
                this.getCommonFieldProps2(Enums.FollowupBasicFields.planningMen, masters),
                this.getCommonFieldProps2(Enums.FollowupBasicFields.menMod, masters),
            ]
        }
        if(fieldName === Enums.FollowupBasicFields.women){
            field.columns = [
                this.getCommonFieldProps2(Enums.FollowupBasicFields.planningWomen, masters),
                this.getCommonFieldProps2(Enums.FollowupBasicFields.womenMod, masters),
            ]
        }
        if(fieldName === Enums.FollowupBasicFields.total){
            field.columns = [
                this.getCommonFieldProps2(Enums.FollowupBasicFields.planningTotal, masters),
                this.getCommonFieldProps2(Enums.FollowupBasicFields.totalMod, masters),
            ]
        }
        if(fieldName === Enums.FollowupBasicFields.baseLine){
            field.width = 300
            field.columns = [
                this.getCommonFieldProps2("lbValue", masters),
                this.getCommonFieldProps2("lbUnity", masters),
                this.getCommonFieldProps2("lbAnio", masters)
            ]
        }
        if(fieldName === Enums.FollowupState.january || fieldName === Enums.FollowupState.february ||
            fieldName === Enums.FollowupState.march || fieldName === Enums.FollowupState.april ||
            fieldName === Enums.FollowupState.may || fieldName === Enums.FollowupState.june ||
            fieldName === Enums.FollowupState.july || fieldName === Enums.FollowupState.august ||
            fieldName === Enums.FollowupState.september || fieldName === Enums.FollowupState.october ||
            fieldName === Enums.FollowupState.november || fieldName === Enums.FollowupState.december 
            ){
                field.columns = [
                    this.getCommonFieldProps2(fieldName + 'Pl', masters),
                    this.getCommonFieldProps2(fieldName + 'Re', masters),
                ]
        }

        
        if(fieldName === Enums.FollowupBasicFields.totalMonthPl) field.calculateCellValue = (data: any) => this.calTotalMonthPl(data)
        
        return field;
    }

    public calTotalMonthPl(data: any){
        const months = Constants.Months.English;
        let value: number = 0
        for (const month of months) value += (data?.[month + 'Pl'] || 0)
        if(!isFinite(value)) value = 0; 
        else value = Number(value.toFixed(2))

        return value;
    }
    

    // ***** DATASOURCE *****

    protected getDataSourceStep1(masters: any) {
        const result: any = [];
        const gnData = this.view.state.data?.genericInfo ? Utilities.copyObject(this.view.state.data?.genericInfo) : null;
        let iLE = null; 
        if (!Utilities.isNullEmptyObject(gnData)) {
            if (!Utilities.isNullEmptyObject(gnData[Enums.ProaBasicFields.IndicadorLE1])) {
                iLE = gnData[Enums.ProaBasicFields.IndicadorLE1]; 
            }
            if (!Utilities.isNullEmptyObject(iLE)) {
                gnData[Enums.ProaBasicFields.IndicadorLE1] = iLE;

                let res = this.getMeasureUnitFromMRI(masters, iLE, Constants.Globals.PREFIX_STRATEGIC_LINE_INDICATOR);
                gnData.PProaUnidadMedida = res;
            }

            gnData.PProaAnioLineaBase = gnData.PProaAnioLineaBase ? typeof gnData.PProaAnioLineaBase.getMonth !== 'function' ? new Date(gnData.PProaAnioLineaBase.split('/')[1], Number(gnData.PProaAnioLineaBase.split('/')[0]) - 1, 1) : gnData.PProaAnioLineaBase : new Date();

            result.push(gnData);
        }

        this.view.state.setDataSource(result)
    }

    protected getDataSourceStep1BF() {
        const bfData = this.view.state.data?.beneficiaries || [];
        const results: any = [];
        if (!Utilities.isNullEmptyObject(bfData)) {
            bfData?.forEach((item: any) => {
                const newItem = { ...item };
                newItem[Enums.ProaBasicFields.TotalGeneral] = item.PPresTotalAnio;
                results.push({ ...newItem });
            });
        }

        this.view.state.setDataSource2(Utilities.sortByKey(results, "PPresuAnio"))
    }

    protected getDataSourceStep2() {
        const ImData = this.view.state.data;
        const results: any = [];
        if (!Utilities.isNullEmptyObject(ImData)) {
            ImData?.forEach((item: any) => {
                const newItem = { ...item.genericInfo };
                newItem.OCTAVIASLEPId = [newItem.OCTAVIASLEPId];
                newItem[Enums.ProaBasicFields.TotalImplementadores] = newItem.PProaImplementadorTotal
                results.push({ ...newItem });
            });
        }
        
        this.view.state.setDataSource(results)
    }

    protected getDataSourceStep3Loc() {
        const data = this.view.state.data;
        let zones = data?.filter((x: any) => !!x.genericInfo?.PProaLocationId)
        const result: any = [];
        if (!Utilities.isNullEmptyObject(zones)) {
            zones?.forEach((item: any, index: number) => {
                const newItem = { ...item.genericInfo };
                newItem.PProaLocationId = [newItem.PProaLocationId];
                newItem[Enums.ProaBasicFields.TotalLocation] = newItem.PFFRRTotal;
                result.push({ ...newItem });
            });
        }

        this.view.state.setDataSource(result)
    }

    protected getDataSourceStep3Adt() {
        const data = this.view.state.data;
        let adts = data?.filter((x: any) => !!x.genericInfo?.PProaAdtId)
        const result: any = [];
        if (!Utilities.isNullEmptyObject(adts)) {
            adts?.forEach((item: any, index: number) => {
                const newItem = { ...item.genericInfo };
                newItem.PProaAdtId = [newItem.PProaAdtId];
                newItem[Enums.ProaBasicFields.Indice] = index + 1;
                newItem[Enums.ProaBasicFields.TotalADT] = newItem.PFFRRTotal;
                result.push({ ...newItem });
            });
        }
        
        this.view.state.setDataSource2(result)
    }

    protected getDataSourceStepSdc() {
        const cpData = this.view.state.data;
        const results: any = [];
        if (!Utilities.isNullEmptyObject(cpData)) {
            cpData?.forEach((item: any, index: number) => {
                const newItem = { ...item.genericInfo };

                let IdContrapartida = newItem.OCTAVIASLEPId ? `IMP${newItem.OCTAVIASLEPId}` : newItem.OCTAVIAFinanciadorSapId 
                                ? `FIN${newItem.OCTAVIAFinanciadorSapId}` : newItem.OCTAVIACodigoFinanciacionId 
                                ? `COD${newItem.OCTAVIACodigoFinanciacionId}` : newItem.Title ? `NEW${newItem.Title}` : null;
                newItem.IdContrapartida = [IdContrapartida];
                newItem.PProaTipoContrapartida = [newItem.PProaTipoContrapartidaId];
                newItem[Enums.ProaBasicFields.TotalContrapartidas] = 0
                item.years?.forEach((x: any) => {
                    let asdd = x.PProaContrapartidaId === newItem?.Id;
                    if(asdd) newItem[Enums.ProaBasicFields.TotalContrapartidas] += x.PProaAnioValue
                })
                results.push({ ...newItem });
            });
        }
        
        this.view.state.setDataSource(results)
    }

    protected getDataSourceStepMri(masters: any) {
        let data: any = [];
        let mriIndicators = this.view.state.data || [];
        data = mriIndicators.map((element: any, index: number) => {
            const newElement: any = { ...element.genericInfo };
            let idMRIPriority = '';
            if (newElement.PFFRRIndicadorResultadoIntermediId?.length > 0 || newElement.PFFRRIndicadorResultadoIntermediId?.results?.length > 0) {
                let indicator = newElement.PFFRRIndicadorResultadoIntermediId?.[0] || newElement.PFFRRIndicadorResultadoIntermediId?.results?.[0]
                idMRIPriority = String.Format("{0}{1}", Constants.Globals.PREFIX_INTERMEDIATE_RESULTS, indicator)
            }
            else if (newElement.PFFRRIndicadorProductoId) {
                idMRIPriority = String.Format("{0}{1}", Constants.Globals.PREFIX_PRODUCT_INDICATOR, newElement.PFFRRIndicadorProductoId)
            }
            else {
                idMRIPriority = String.Format("{0}{1}", Constants.Globals.PREFIX_STRATEGIC_LINE_INDICATOR, newElement.PPresIndicadorLineaEstrategicaId)
            }

            newElement[Enums.ProaBasicFields.Indice] = index + 1;
            newElement.PProaMRIPriority = idMRIPriority;
            newElement.PProaAnioLineaBase = newElement.PProaAnioLineaBase ? typeof newElement.PProaAnioLineaBase.getMonth !== 'function' ? new Date(newElement.PProaAnioLineaBase.split('/')[1], Number(newElement.PProaAnioLineaBase.split('/')[0]) - 1, 1) : newElement.PProaAnioLineaBase : null;
            let res = this.getMeasureUnitFromMRI(masters, idMRIPriority, null);
            newElement.PProaUnidadMedida = res;

            return newElement;
        });

        this.view.state.setDataSource(data)
    }

    protected getDataSourceStepObj() {
        let data: any = [];
        let objetives = this.view.state.data || [];

        data = objetives.map((element: any, index: number) => {
            const newElement: any = { ...element.genericInfo };
            newElement.PProaAnioLineaBase = newElement.PProaAnioLineaBase ? typeof newElement.PProaAnioLineaBase.getMonth !== 'function' ? new Date(newElement.PProaAnioLineaBase.split('/')[1], Number(newElement.PProaAnioLineaBase.split('/')[0]) - 1, 1) : newElement.PProaAnioLineaBase : null;
            return newElement;
        });

        this.view.state.setDataSource(data)
    }

    protected getDataSourceStepRes() {
        let data: any = [];
        let results = this.view.state.data || [];

        data = results?.map((element: any, index: number) => {
            const newElement: any = { ...element.genericInfo };
            newElement.PProaAnioLineaBase = newElement.PProaAnioLineaBase ? typeof newElement.PProaAnioLineaBase.getMonth !== 'function' ? new Date(newElement.PProaAnioLineaBase.split('/')[1], Number(newElement.PProaAnioLineaBase.split('/')[0]) - 1, 1) : newElement.PProaAnioLineaBase : null;
            newElement[Enums.ProaBasicFields.Indice] = index + 1;
            newElement.PSPCMRIObjetivo = newElement.PProaIndicadorObjetivo;
            return newElement;
        });

        this.view.state.setDataSource(data)
    }

    protected getDataSourceStepAct() {
        let data: any = [];

        let activities = this.view.state.data || [];

        data = activities?.map((element: any, index: number) => {
            const newElement: any = { ...element.genericInfo };
            newElement[Enums.ProaBasicFields.Indice] = index + 1;
            return newElement;
        });
        
        this.view.state.setDataSource(data)
    }

    // ***** FUNCTIONS *****

    public onSelectionChangedStep(e: any, section?: string) {
        let element = e?.selectedRowsData[0]
        let years: any[] = [], newYears: any[] = []
        
        if(!!element){
            let itemYears = Array.isArray(this.view.state.data) ? this.view.state.data?.find((x: any) => x.genericInfo?.Id === element?.Id)?.years || [] : this.view.state.data?.years || []

            itemYears?.forEach((x: any) => {
                if(!years?.includes(x.PPresAnioMeta)){
                    newYears.push(x)
                    years?.push(x.PPresAnioMeta)
                }
            })

            newYears = newYears.sort((a: any, b: any) => ((a.PPresAnioMeta < b.PPresAnioMeta) ? -1 : ((a.PPresAnioMeta > b.PPresAnioMeta) ? 1 : 0)));

            if(section === "Adt") this.view.state.setItemYears2(newYears)
            else this.view.state.setItemYears(newYears)
        }else this.view.state.setItemYears(null)
    }

    public getStep4Res(current: any, followUpFatherIds: any[]){
        let itemsToDeleteRes: any = []
        let resInd = this.stepsData.step4.results.details?.filter((x: any) => x.PProaFEStep4ResultadosEsperadosId === current?.Id)
        let resIndIds = resInd.map((y: any) => y?.Id)
        let resIndYears = this.stepsData.step4.results.years?.filter((x: any) => resIndIds.includes(x.PProaFEStep4ResultadoDetalleId))
        let resIndYearIds = resIndYears.map((y: any) => y?.Id)

        let actInd = this.stepsData.step4.activities.base?.filter((x: any) => x.PProaFEStep4ResultadosEsperadosId === current?.Id)
        let actIndIds = actInd.map((y: any) => y?.Id)
        let actIndYears = this.stepsData.step4.activities.years?.filter((x: any) => actIndIds.includes(x.PProaFEStep4ActividadId))
        let actIndYearIds = actIndYears.map((y: any) => y?.Id)

        let indResEsperados = this.followUpData.indResEsperados?.filter((x: any) => followUpFatherIds.includes(x.SubProyectoAnioId) && resIndYearIds.includes(x.IndicadorResultadoEsperadoAnioId))
        let indActividades = this.followUpData.indActividades?.filter((x: any) => followUpFatherIds.includes(x.SubProyectoAnioId) && actIndYearIds.includes(x.IndicadorActividadAnioId))
        let benByResult = this.followUpData.benByResult?.filter((x: any) => followUpFatherIds.includes(x.SubProyectoAnioId) && actIndYearIds.includes(x.IndicadorActividadAnioId))
        let finResults = this.followUpData.finResults?.filter((x: any) => followUpFatherIds.includes(x.SubProyectoAnioId) && actIndYearIds.includes(x.IndicadorActividadAnioId))

        let benByOverlap = this.followUpData.benByOverlap?.filter((x: any) => followUpFatherIds.includes(x.SubProyectoAnioId) && (x.PProaFEStep4ResultadosEsperadosId === current.Id || x.SegBenefParentId === current.Id))
        let finTotalsResults = this.followUpData.finTotalsResults?.filter((x: any) => followUpFatherIds.includes(x.SubProyectoAnioId) && x.PProaFEStep4ResultadosEsperadosId === current.Id)

        let infoFollowUpRes: any[] = [...indResEsperados, ...indActividades, ...benByResult, ...finResults, ...benByOverlap, ...finTotalsResults]

        itemsToDeleteRes.push({listName: Enums.ListTypes.ProaSubproyectoFEStep4Resultados, item: current})

        benByOverlap?.forEach((x: any) => {
            itemsToDeleteRes.push({listName: Enums.ListTypes.BeneficiariesByOverlap, item: x})
        })

        finTotalsResults?.forEach((x: any) => {
            itemsToDeleteRes.push({listName: Enums.ListTypes.FinancieraResultadosEsperadosTotales, item: x})
        })

        // Detalles
        resInd?.forEach((x: any) => {
            itemsToDeleteRes.push({listName: Enums.ListTypes.ProaSubproyectoFEStep4ResultadosDetalles, item: x})
        })

        resIndYears?.forEach((x: any) => {
            itemsToDeleteRes.push({listName: Enums.ListTypes.ProaSubproyectoFEStep4ResultadosDetallesAnios, item: x})
        })

        indResEsperados?.forEach((x: any) => {
            itemsToDeleteRes.push({listName: Enums.ListTypes.SeguimientoResultadosEsperados, item: x})
        })

        // Actividades
        actInd?.forEach((x: any) => {
            itemsToDeleteRes.push({listName: Enums.ListTypes.ProaSubproyectoFEStep4Actividad, item: x})
        })

        actIndYears?.forEach((x: any) => {
            itemsToDeleteRes.push({listName: Enums.ListTypes.ProaSubproyectoFEStep4ActividadAnios, item: x})
        })

        indActividades?.forEach((x: any) => {
            itemsToDeleteRes.push({listName: Enums.ListTypes.SeguimientoActividades, item: x})
        })

        benByResult?.forEach((x: any) => {
            itemsToDeleteRes.push({listName: Enums.ListTypes.BeneficiariesByResult, item: x})
        })

        finResults?.forEach((x: any) => {
            itemsToDeleteRes.push({listName: Enums.ListTypes.FinancieraResultadosEsperados, item: x})
        })

        return {itemsToDeleteRes, infoFollowUpRes}
    }

    public async handleDelete(e: any, section: string, isYear: boolean) {
        let followUpFatherIds: any[] = [] 
        let popId: any = null
        let current = e.row?.data
        let item = !isYear ? current : null
        let itemYears = isYear ? [current] : []
        let subvencionCode: string = null
        let itemsToDelete: any[] = []
        let infoFollowUp: any[] = []
        let sectionLabel: string = null

        if(!current) return true;

        switch (section) {
            case "Step1": {
                if(isYear){
                    item = this.stepsData.step1.base?.find((x: any) => x.Id === current?.PProaFRStep1Id)
                    itemsToDelete.push({listName: Enums.ListTypes.ProaSubproyectoFRStep1Anios, item: current})
                }else{
                    sectionLabel = "AlertSectionStep1"
                    itemYears = this.stepsData.step1.years?.filter((x: any) => item?.Id === x.PProaFRStep1Id)
                    itemsToDelete.push({listName: Enums.ListTypes.ProaSubproyectoFRStep1, item: current})
                    itemYears?.forEach((x: any) => {
                        itemsToDelete.push({listName: Enums.ListTypes.ProaSubproyectoFRStep1Anios, item: x})
                    })
                }
                let itemsYearIds = itemYears.map((x: any) => x.Id)
                popId = item?.PPresPresupuestoId
                subvencionCode = item?.PPresCodSubvencionId ? this.formMasters.grantCodes?.find((x: any) => x.Id === item?.PPresCodSubvencionId)?.Title : null
                followUpFatherIds = this.followUpData.followIndex
                    ?.filter((x: any) => (x.IdProyecto === popId && x.CodigoSubvencion === subvencionCode && ((isYear && Number(x.Anio) === current?.PPresAnioMeta) || !isYear)))
                    .map((y: any) => y?.Id)

                let indLineaPrincipal = this.followUpData.indLineaPrincipal?.filter((x: any) => followUpFatherIds.includes(x.SubProyectoAnioId) && itemsYearIds.includes(x.IndicadorLineaEstrategicaAniosId))

                indLineaPrincipal?.forEach((x: any) => {
                    itemsToDelete.push({listName: Enums.ListTypes.SeguimientoLineaPrincipal, item: x})
                })

                infoFollowUp = [...infoFollowUp, ...indLineaPrincipal]

                if(!isYear){
                    let beneficiaries = this.stepsData.step1.yearsBeneficiaries?.filter((x: any) => item?.Id === x.PProaFRStep1Id)
                    let beneficiariesIds = beneficiaries?.map((x: any) => x.Id)
                    beneficiaries?.forEach((x: any) => {
                        itemsToDelete.push({listName: Enums.ListTypes.BaseFFRRBeneficiarios, item: x})
                    })
                    let benBySubPr = this.followUpData.benBySubPr?.filter((x: any) => followUpFatherIds.includes(x.SubProyectoAnioId) && beneficiariesIds.includes(x.SPCBeneficiariosAniosId))
                    benBySubPr?.forEach((x: any) => {
                        itemsToDelete.push({listName: Enums.ListTypes.BeneficiariesBySubPr, item: x})
                    })
                    infoFollowUp = [...infoFollowUp, ...benBySubPr]
                }
            }; break;
            case "Step1Bf": {
                itemsToDelete.push({listName: Enums.ListTypes.BaseFFRRBeneficiarios, item: current})
               
                popId = current?.PPresPresupuestoId
                subvencionCode = item?.PPresCodSubvencionId ? this.formMasters.grantCodes?.find((x: any) => x.Id === item?.PPresCodSubvencionId)?.Title : null
                followUpFatherIds = this.followUpData.followIndex
                    ?.filter((x: any) => (x.IdProyecto === popId && x.CodigoSubvencion === subvencionCode && Number(current.PPresuAnio) === Number(x.Anio))).map((y: any) => y?.Id)

                let benBySubPr = this.followUpData.benBySubPr?.find((x: any) => followUpFatherIds.includes(x.SubProyectoAnioId) && x.SPCBeneficiariosAniosId === current?.Id)

                if(!!benBySubPr){
                    itemsToDelete.push({listName: Enums.ListTypes.BeneficiariesBySubPr, item: benBySubPr})
                    infoFollowUp = [benBySubPr]
                }
            }; break;
            case "Step2": {
                if(isYear){
                    item = this.stepsData.step2.base?.find((x: any) => x.Id === current?.PProaFRStep2Id)
                    itemsToDelete.push({listName: Enums.ListTypes.ProaSubproyectoFRStep2Anios, item: current})
                }else{
                    sectionLabel = "AlertSectionStep2"
                    itemYears = this.stepsData.step2.years?.filter((x: any) => item?.Id === x.PProaFRStep2Id)
                    itemsToDelete.push({listName: Enums.ListTypes.ProaSubproyectoFRStep2, item: current})
                    itemYears?.forEach((x: any) => {
                        itemsToDelete.push({listName: Enums.ListTypes.ProaSubproyectoFRStep2Anios, item: x})
                    })
                }
                let itemsYearIds = itemYears.map((x: any) => x.Id)
                popId = item?.PPresPresupuestoId
                subvencionCode = item?.PPresCodSubvencionId ? this.formMasters.grantCodes?.find((x: any) => x.Id === item?.PPresCodSubvencionId)?.Title : null
                followUpFatherIds = this.followUpData.followIndex
                    ?.filter((x: any) => (x.IdProyecto === popId && x.CodigoSubvencion === subvencionCode && ((isYear && Number(x.Anio) === current?.PPresAnioMeta) || !isYear)))
                    .map((y: any) => y?.Id)

                infoFollowUp = this.followUpData.finImplementers?.filter((x: any) => followUpFatherIds.includes(x.SubProyectoAnioId) && itemsYearIds.includes(x.PProaFRStep2AniosId))

                infoFollowUp?.forEach((x: any) => {
                    itemsToDelete.push({listName: Enums.ListTypes.FinancieraPresupuestoImplementadores, item: x})
                })
            }; break;
            case "StepSdc": {
                if(isYear){
                    item = this.stepsData.stepSDC.base?.find((x: any) => x.Id === current?.PProaContrapartidaId)
                    itemsToDelete.push({listName: Enums.ListTypes.ProaSubproyectoFRStepSDCAnios, item: current})
                }else{
                    sectionLabel = "AlertSectionStepSDC"
                    itemYears = this.stepsData.stepSDC.years?.filter((x: any) => item?.Id === x.PProaContrapartidaId)
                    itemsToDelete.push({listName: Enums.ListTypes.ProaSubproyectoFRStepSDC, item: current})
                    itemYears?.forEach((x: any) => {
                        itemsToDelete.push({listName: Enums.ListTypes.ProaSubproyectoFRStepSDCAnios, item: x})
                    })
                }
                let itemsYearIds = itemYears.map((x: any) => x.Id)
                popId = item?.PPresPresupuestoId
                subvencionCode = item?.PPresCodSubvencionId ? this.formMasters.grantCodes?.find((x: any) => x.Id === item?.PPresCodSubvencionId)?.Title : null
                followUpFatherIds = this.followUpData.followIndex
                    ?.filter((x: any) => (x.IdProyecto === popId && x.CodigoSubvencion === subvencionCode && ((isYear && Number(x.Anio) === current?.PPresAnioMeta) || !isYear)))
                    .map((y: any) => y?.Id)

                infoFollowUp = this.followUpData.finSdcs?.filter((x: any) => followUpFatherIds.includes(x.SubProyectoAnioId) && itemsYearIds.includes(x.PProaContrapartidaAnioId))

                infoFollowUp?.forEach((x: any) => {
                    itemsToDelete.push({listName: Enums.ListTypes.FinancieraPresupuestoSDC, item: x})
                })
            }; break;
            case "Step3Loc": {
                if(isYear){
                    item = this.stepsData.step3.base?.find((x: any) => x.Id === current?.PProaFRStep3Id)
                    itemsToDelete.push({listName: Enums.ListTypes.ProaSubproyectoFRStep3Anios, item: current})
                }else{
                    sectionLabel = "AlertSectionStep3Loc"
                    itemYears = this.stepsData.step3.years?.filter((x: any) => item?.Id === x.PProaFRStep3Id)
                    itemsToDelete.push({listName: Enums.ListTypes.ProaSubproyectoFRStep3, item: current})
                    itemYears?.forEach((x: any) => {
                        itemsToDelete.push({listName: Enums.ListTypes.ProaSubproyectoFRStep3Anios, item: x})
                    })
                }
                let itemsYearIds = itemYears.map((x: any) => x.Id)

                popId = item?.PPresPresupuestoId
                subvencionCode = item?.PPresCodSubvencionId ? this.formMasters.grantCodes?.find((x: any) => x.Id === item?.PPresCodSubvencionId)?.Title : null
                followUpFatherIds = this.followUpData.followIndex
                    ?.filter((x: any) => (x.IdProyecto === popId && x.CodigoSubvencion === subvencionCode && ((isYear && Number(x.Anio) === current?.PPresAnioMeta) || !isYear)))
                    .map((y: any) => y?.Id)

                let finLocations = this.followUpData.finLocations?.filter((x: any) => followUpFatherIds.includes(x.SubProyectoAnioId) && itemsYearIds.includes(x.PProaFRStep3AniosId))
                let auxInfo = this.followUpData.benByLocation?.filter((x: any) => followUpFatherIds.includes(x.SubProyectoAnioId) && (x.PProaLocationId === item?.PProaLocationId?.[0] || x.PProaLocationId === item?.PProaLocationId))

                finLocations?.forEach((x: any) => {
                    itemsToDelete.push({listName: Enums.ListTypes.FinancieraPresupuestoLocalizaciones, item: x})
                })
                auxInfo?.forEach((x: any) => {
                    itemsToDelete.push({listName: Enums.ListTypes.BeneficiariesByLocation, item: x})
                })

                infoFollowUp = [...finLocations, ...auxInfo]
            }; break;
            case "Step3Adt": {
                if(isYear){
                    item = this.stepsData.step3.base?.find((x: any) => x.Id === current?.PProaFRStep3Id)
                    itemsToDelete.push({listName: Enums.ListTypes.ProaSubproyectoFRStep3Anios, item: current})
                }else{
                    sectionLabel = "AlertSectionStep3Adt"
                    itemYears = this.stepsData.step3.years?.filter((x: any) => item?.Id === x.PProaFRStep3Id)
                    itemsToDelete.push({listName: Enums.ListTypes.ProaSubproyectoFRStep3, item: current})
                    itemYears?.forEach((x: any) => {
                        itemsToDelete.push({listName: Enums.ListTypes.ProaSubproyectoFRStep3Anios, item: x})
                    })
                }
                let itemsYearIds = itemYears.map((x: any) => x.Id)
                popId = item?.PPresPresupuestoId
                subvencionCode = item?.PPresCodSubvencionId ? this.formMasters.grantCodes?.find((x: any) => x.Id === item?.PPresCodSubvencionId)?.Title : null
                followUpFatherIds = this.followUpData.followIndex
                    ?.filter((x: any) => (x.IdProyecto === popId && x.CodigoSubvencion === subvencionCode && ((isYear && Number(x.Anio) === current?.PPresAnioMeta) || !isYear)))
                    .map((y: any) => y?.Id)

                infoFollowUp = this.followUpData.finAdts?.filter((x: any) => followUpFatherIds.includes(x.SubProyectoAnioId) && itemsYearIds.includes(x.PProaFRStep3AniosId))

                infoFollowUp?.forEach((x: any) => {
                    itemsToDelete.push({listName: Enums.ListTypes.FinancieraPresupuestoADT, item: x})
                })
            }; break;
            case "Step4Mri": {
                if(isYear){
                    item = this.stepsData.step4.mri.base?.find((x: any) => x.Id === current?.PProaStep4AdaptacionMRIId)
                    itemsToDelete.push({listName: Enums.ListTypes.ProaSubproyectoFEStep4MRIAnios, item: current})
                }else{
                    sectionLabel = "AlertSectionStep4MRI"
                    itemYears = this.stepsData.step4.mri.years?.filter((x: any) => item?.Id === x.PProaStep4AdaptacionMRIId)
                    itemsToDelete.push({listName: Enums.ListTypes.ProaSubproyectoFEStep4MRI, item: current})
                    itemYears?.forEach((x: any) => {
                        itemsToDelete.push({listName: Enums.ListTypes.ProaSubproyectoFEStep4MRIAnios, item: x})
                    })
                }
                let itemsYearIds = itemYears.map((x: any) => x.Id)
                popId = item?.PPresPresupuestoId
                subvencionCode = item?.PPresCodSubvencionId ? this.formMasters.grantCodes?.find((x: any) => x.Id === item?.PPresCodSubvencionId)?.Title : null
                followUpFatherIds = this.followUpData.followIndex
                    ?.filter((x: any) => (x.IdProyecto === popId && x.CodigoSubvencion === subvencionCode && ((isYear && Number(x.Anio) === current?.PPresAnioMeta) || !isYear)))
                    .map((y: any) => y?.Id)

                let indLineaSecundaria = this.followUpData.indLineaSecundaria?.filter((x: any) => followUpFatherIds.includes(x.SubProyectoAnioId) && itemsYearIds.includes(x.IndLineaEstrategicaAniosSecundarId))
                let indResInstitucionales = this.followUpData.indResInstitucionales?.filter((x: any) => followUpFatherIds.includes(x.SubProyectoAnioId) && itemsYearIds.includes(x.IndicadorInstitucionalResultados0Id))
                let indProInstitucionales = this.followUpData.indProInstitucionales?.filter((x: any) => followUpFatherIds.includes(x.SubProyectoAnioId) && itemsYearIds.includes(x.IndicadorInstitucionalProductosAId))

                indLineaSecundaria?.forEach((x: any) => {
                    itemsToDelete.push({listName: Enums.ListTypes.SeguimientoLineaSecundaria, item: x})
                })

                indResInstitucionales?.forEach((x: any) => {
                    itemsToDelete.push({listName: Enums.ListTypes.SeguimientoResultadosInstitucionales, item: x})
                })

                indProInstitucionales?.forEach((x: any) => {
                    itemsToDelete.push({listName: Enums.ListTypes.SeguimientoProductosInstitucionales, item: x})
                })

                infoFollowUp = [...indLineaSecundaria, ...indResInstitucionales, ...indProInstitucionales]
            }; break;
            case "Step4Act": {
                if(isYear){
                    let itemAct = this.stepsData.step4.activities.base?.find((x: any) => x.Id === current?.PProaFEStep4ActividadId)
                    let itemRes = this.stepsData.step4.results.base?.find((x: any) => x.Id === itemAct?.PProaFEStep4ResultadosEsperadosId)
                    let itemObj = this.stepsData.step4.objetives?.find((x: any) => x.Id === itemRes?.PProaFEStep4Id)
                    popId = itemObj?.PPresPresupuestoId
                    subvencionCode = itemObj?.PPresCodSubvencionId ? this.formMasters.grantCodes?.find((x: any) => x.Id === itemObj?.PPresCodSubvencionId)?.Title : null
                    itemsToDelete.push({listName: Enums.ListTypes.ProaSubproyectoFEStep4ActividadAnios, item: current})
                }else{
                    sectionLabel = "AlertSectionStep4Act"
                    itemYears = this.stepsData.step4.activities.years?.filter((x: any) => item?.Id === x.PProaFEStep4ActividadId)
                    let itemRes = this.stepsData.step4.results.base?.find((x: any) => x.Id === item?.PProaFEStep4ResultadosEsperadosId)
                    let itemObj = this.stepsData.step4.objetives?.find((x: any) => x.Id === itemRes?.PProaFEStep4Id)
                    popId = itemObj?.PPresPresupuestoId
                    subvencionCode = itemObj?.PPresCodSubvencionId ? this.formMasters.grantCodes?.find((x: any) => x.Id === itemObj?.PPresCodSubvencionId)?.Title : null
                    itemsToDelete.push({listName: Enums.ListTypes.ProaSubproyectoFEStep4Actividad, item: current})
                    itemYears?.forEach((x: any) => {
                        itemsToDelete.push({listName: Enums.ListTypes.ProaSubproyectoFEStep4ActividadAnios, item: x})
                    })
                }
                let itemsYearIds = itemYears.map((x: any) => x.Id)
                followUpFatherIds = this.followUpData.followIndex
                    ?.filter((x: any) => (x.IdProyecto === popId && x.CodigoSubvencion === subvencionCode && ((isYear && Number(x.Anio) === current?.PPresAnioMeta) || !isYear)))
                    .map((y: any) => y?.Id)

                let indActividades = this.followUpData.indActividades?.filter((x: any) => followUpFatherIds.includes(x.SubProyectoAnioId) && itemsYearIds.includes(x.IndicadorActividadAnioId))
                let benByResult = this.followUpData.benByResult?.filter((x: any) => followUpFatherIds.includes(x.SubProyectoAnioId) && itemsYearIds.includes(x.IndicadorActividadAnioId))
                let finResults = this.followUpData.finResults?.filter((x: any) => followUpFatherIds.includes(x.SubProyectoAnioId) && itemsYearIds.includes(x.IndicadorActividadAnioId))

                indActividades?.forEach((x: any) => {
                    itemsToDelete.push({listName: Enums.ListTypes.SeguimientoActividades, item: x})
                })

                benByResult?.forEach((x: any) => {
                    itemsToDelete.push({listName: Enums.ListTypes.BeneficiariesByResult, item: x})
                })

                finResults?.forEach((x: any) => {
                    itemsToDelete.push({listName: Enums.ListTypes.FinancieraResultadosEsperados, item: x})
                })

                infoFollowUp = [...indActividades, ...benByResult, ...finResults]
            }; break;
            case "Step4ResInd": {
                if(isYear){
                    let itemAct = this.stepsData.step4.results.details?.find((x: any) => x.Id === current?.PProaFEStep4ResultadoDetalleId)
                    let itemRes = this.stepsData.step4.results.base?.find((x: any) => x.Id === itemAct?.PProaFEStep4ResultadosEsperadosId)
                    let itemObj = this.stepsData.step4.objetives?.find((x: any) => x.Id === itemRes?.PProaFEStep4Id)
                    popId = itemObj?.PPresPresupuestoId
                    subvencionCode = itemObj?.PPresCodSubvencionId ? this.formMasters.grantCodes?.find((x: any) => x.Id === itemObj?.PPresCodSubvencionId)?.Title : null
                    itemsToDelete.push({listName: Enums.ListTypes.ProaSubproyectoFEStep4ResultadosDetallesAnios, item: current})
                }else{
                    sectionLabel = "AlertSectionStep4ResInd"
                    itemYears = this.stepsData.step4.results.years?.filter((x: any) => item?.Id === x.PProaFEStep4ResultadoDetalleId)
                    let itemRes = this.stepsData.step4.results.base?.find((x: any) => x.Id === item?.PProaFEStep4ResultadosEsperadosId)
                    let itemObj = this.stepsData.step4.objetives?.find((x: any) => x.Id === itemRes?.PProaFEStep4Id)
                    popId = itemObj?.PPresPresupuestoId
                    subvencionCode = itemObj?.PPresCodSubvencionId ? this.formMasters.grantCodes?.find((x: any) => x.Id === itemObj?.PPresCodSubvencionId)?.Title : null
                    itemsToDelete.push({listName: Enums.ListTypes.ProaSubproyectoFEStep4ResultadosDetalles, item: current})
                    itemYears?.forEach((x: any) => {
                        itemsToDelete.push({listName: Enums.ListTypes.ProaSubproyectoFEStep4ResultadosDetallesAnios, item: x})
                    })
                }
                let itemsYearIds = itemYears.map((x: any) => x.Id)
                followUpFatherIds = this.followUpData.followIndex
                    ?.filter((x: any) => (x.IdProyecto === popId && x.CodigoSubvencion === subvencionCode && ((isYear && Number(x.Anio) === current?.PPresAnioMeta) || !isYear)))
                    .map((y: any) => y?.Id)

                infoFollowUp = this.followUpData.indResEsperados?.filter((x: any) => followUpFatherIds.includes(x.SubProyectoAnioId) && itemsYearIds.includes(x.IndicadorResultadoEsperadoAnioId))
                
                infoFollowUp?.forEach((x: any) => {
                    itemsToDelete.push({listName: Enums.ListTypes.SeguimientoResultadosEsperados, item: x})
                })
            }; break;
            case "Step4Res": {
                sectionLabel = "AlertSectionStep4Res"
                let itemObj = this.stepsData.step4.objetives?.find((x: any) => x.Id === current?.PProaFEStep4Id)
                popId = itemObj?.PPresPresupuestoId
                subvencionCode = itemObj?.PPresCodSubvencionId ? this.formMasters.grantCodes?.find((x: any) => x.Id === itemObj?.PPresCodSubvencionId)?.Title : null
                followUpFatherIds = this.followUpData.followIndex
                    ?.filter((x: any) => (x.IdProyecto === popId && x.CodigoSubvencion === subvencionCode)).map((y: any) => y?.Id)

                let { itemsToDeleteRes, infoFollowUpRes } = this.getStep4Res(current, followUpFatherIds)
                itemsToDelete = itemsToDeleteRes
                infoFollowUp = infoFollowUpRes
            }; break;
            case "Step4ObjInd": {
                if(isYear){
             
                    let item = this.stepsData.step4.specificObjetives.base?.find((x: any) => x.Id === current?.PProaFEStep4InidicadorId)
                    let itemObj = this.stepsData.step4.objetives?.find((x: any) => x.Id === item?.PProaFEStep4Id)
                    popId = itemObj?.PPresPresupuestoId
                    subvencionCode = itemObj?.PPresCodSubvencionId ? this.formMasters.grantCodes?.find((x: any) => x.Id === itemObj?.PPresCodSubvencionId)?.Title : null
                    itemsToDelete.push({listName: Enums.ListTypes.ProaSubproyectoFEStep4ObjetivoAnios, item: current})
                }else{
                    sectionLabel = "AlertSectionStep4ObjInd"
                    itemYears = this.stepsData.step4.specificObjetives.years?.filter((x: any) => item?.Id === x.PProaFEStep4InidicadorId)
                    let itemObj = this.stepsData.step4.objetives?.find((x: any) => x.Id === item?.PProaFEStep4Id)
                    popId = itemObj?.PPresPresupuestoId
                    subvencionCode = itemObj?.PPresCodSubvencionId ? this.formMasters.grantCodes?.find((x: any) => x.Id === itemObj?.PPresCodSubvencionId)?.Title : null
                    itemsToDelete.push({listName: Enums.ListTypes.ProaSubproyectoFEStep4Objetivo, item: current})
                    itemYears?.forEach((x: any) => {
                        itemsToDelete.push({listName: Enums.ListTypes.ProaSubproyectoFEStep4ObjetivoAnios, item: x})
                    })
                }
           
                let itemsYearIds = itemYears.map((x: any) => x.Id)
                followUpFatherIds = this.followUpData.followIndex
                    ?.filter((x: any) => (x.IdProyecto === popId && x.CodigoSubvencion === subvencionCode && ((isYear && Number(x.Anio) === current?.PPresAnioMeta) || !isYear)))
                    .map((y: any) => y?.Id)

                infoFollowUp = this.followUpData.indObjEspecificos?.filter((x: any) => followUpFatherIds.includes(x.SubProyectoAnioId) && itemsYearIds.includes(x.IndicadorObjetivoAnioId))
                
                infoFollowUp?.forEach((x: any) => {
                    itemsToDelete.push({listName: Enums.ListTypes.SeguimientoIndObjEspecificos, item: x})
                })
            }; break;
            case "Step4Obj": {
                sectionLabel = "AlertSectionStep4Obj"
                itemsToDelete.push({listName: Enums.ListTypes.ProaSubproyectoFEStep4, item: current})

                popId = current?.PPresPresupuestoId
                subvencionCode = current?.PPresCodSubvencionId ? this.formMasters.grantCodes?.find((x: any) => x.Id === current?.PPresCodSubvencionId)?.Title : null
                followUpFatherIds = this.followUpData.followIndex
                    ?.filter((x: any) => (x.IdProyecto === popId && x.CodigoSubvencion === subvencionCode)).map((y: any) => y?.Id)
                
                let objInd = this.stepsData.step4.specificObjetives.base?.filter((x: any) => x.PProaFEStep4Id === current?.Id)
                let objIndIds = objInd.map((y: any) => y?.Id)
                let objIndYears = this.stepsData.step4.specificObjetives.years?.filter((x: any) => objIndIds.includes(x.PProaFEStep4InidicadorId))
                let objIndYearIds = objIndYears.map((y: any) => y?.Id)

                objInd?.forEach((x: any) => {
                    itemsToDelete.push({listName: Enums.ListTypes.ProaSubproyectoFEStep4Actividad, item: x})
                })
        
                objIndYears?.forEach((x: any) => {
                    itemsToDelete.push({listName: Enums.ListTypes.ProaSubproyectoFEStep4ObjetivoAnios, item: x})
                })

                let indObjEspecificos = this.followUpData.indObjEspecificos?.filter((x: any) => followUpFatherIds.includes(x.SubProyectoAnioId) && objIndYearIds.includes(x.IndicadorObjetivoAnioId))
                
                indObjEspecificos?.forEach((x: any) => {
                    itemsToDelete.push({listName: Enums.ListTypes.SeguimientoIndObjEspecificos, item: x})
                })

                infoFollowUp = [...infoFollowUp, ...indObjEspecificos]
                let results = this.stepsData.step4.results.base?.filter((x: any) => x.PProaFEStep4Id === current?.Id)

                results?.forEach((x: any) => {
                    let { itemsToDeleteRes, infoFollowUpRes } = this.getStep4Res(x, followUpFatherIds)
                    itemsToDelete = [...itemsToDelete, ...itemsToDeleteRes]
                    infoFollowUp = [...infoFollowUp, ...infoFollowUpRes]
                })
            }; break;
        }

        console.log('itemsToDelete', itemsToDelete)

        if(!!infoFollowUp?.length){
            Utilities.showConfirmation2(this.currentLabels.get("MessageDeletingWithFollowUp"), this.currentLabels.get("MessageDeletingWithFollowUp2"), this.currentLabels.get("MessageToSee"), this.handleOpenModal)
                .then(async (res) => {
                    if(res){
                        await this.deleteItems(itemsToDelete).then(()=>{this.clear()})
                       
                    }else{
                        this.dispatcher(this.context.popStore.handleInfoToDelete(null, null));
                        setTimeout(() => {
                            this.dispatcher(this.context.popStore.handleInfoToDelete(infoFollowUp, itemsToDelete)); 
                        }, 50);
                    }
                })
        }else if(isYear){
            Utilities.showConfirmation(this.currentLabels.get("MessageDeletingYear"), undefined, undefined, undefined, 'warning')
                .then(async (res) => {
                    if(res){
                        await this.deleteItems(itemsToDelete).then(()=>{this.clear()})
                        
                    }
                })
        }else{
            let labelW = this.currentLabels.get(sectionLabel) +
            `<p className="swal2-html-container" style="margin-top: 30px; font-size: inherit;" >${this.currentLabels.get("ContinueAction")}</p>`
            Utilities.showConfirmation(labelW, undefined, undefined, undefined, 'warning')
                .then(async (res) => {
                    if(res){
                        await this.deleteItems(itemsToDelete).then(()=>{this.clear()})
                      
                    }
                })
        }
    }

    private handleOpenModal() {
        this.dispatcher(this.context.popStore.handleOpenModal(true)); 
        Swal.close()
    }

    private async deleteItems(itemsToDelete: any[]) {
        Utilities.showLoading(this.currentLabels.get("RemovingMessage"), this.currentLabels.get("loadingMessage"))
        let auxItems: any = {}

        for (const element of itemsToDelete) {
            if(auxItems[element.listName]) auxItems[element.listName] = [...auxItems[element.listName], element.item]
            else auxItems[element.listName] = [element.item]
        }

        let dataKeys: any = Object.keys(auxItems) || []

        let response = await Promise.all([
            ...dataKeys.map(async (listName : string) => {
                if(!!auxItems?.[listName]?.length){
                    return await this.popService.deleteItems(listName, auxItems[listName])
                }
            })
        ])

        
        return response
    }

    private getDeleteColumn(section: string, isYear: boolean = false) {
        return {
            caption: this.currentLabels.get("Acciones"),
            dataField: "botones",
            alignment: "center",
            fieldType: "Button",
            type: "buttons",
            minWidth: 100,
            buttons: [
                {
                    hint: this.currentLabels.get("Eliminar"),
                    icon: "trash",
                    visible: true,
                    onClick: (e: any) => this.handleDelete(e, section, isYear),
                }
            ],
        }
    }

    public getAdminPermissions(){
        const ADMIN_GROUP = this.params?.[Enums.Params.proyectaAdminModule]
        let userGroups: any[] = this?.currentUser?.userGroups?.map((x: any) => x.displayName)

        return (userGroups?.includes(ADMIN_GROUP))
    }

    public getUserPermissions(){
        return (this?.currentUser?.currentUser?.userPrincipalName === "syntax@ayudaenaccion.org")
    }

    private getCommonFieldProps(fieldName: string, masters?: any, plus?: boolean) {
        const fieldProps = this.view.state.columns?.get(fieldName);
        const field: any = {
            alignment: "center",
            dataField: fieldProps?.Title || "",
            title: fieldProps?.NombreColumna || "",
            fieldType: fieldProps?.TipoCampoProyecta || Enums.FieldTypes.Text,
            id: `${fieldProps?.Title || ""}_adminPop ${plus && "plus"}`,
            readOnly: fieldProps.OCTAVIASoloVista,
            visible: fieldProps.OCTAVIAVisible,
            width: 200
        };

        if (fieldName === Enums.ProaBasicFields.IdContrapartida.toString()) {
            let data = masters.implementators;
            let items = Utilities.processDropDownData(data?.filter((x: any) => (x.OCTAVIAActivo)), Enums.ListTypes.ProaSubproyectoFRStepSDC,"", "IMP");
            data = masters.ffrrFinancer
            items = items.concat(Utilities.processDropDownData(data?.filter((x: any) => (x.OCTAVIAActivo)), Enums.ListTypes.ProaSubproyectoFRStepSDC,"", "FIN"));
            data = masters.grantCodes
            items = items.concat(Utilities.processDropDownData(data?.filter((x: any) => (x.OCTAVIAActivo)), Enums.ListTypes.ProaSubproyectoFRStepSDC,"", "COD"));
            let allData = masters.implementators;
            let allItems = Utilities.processDropDownData(allData, Enums.ListTypes.ProaSubproyectoFRStepSDC,"", "IMP");
            allData = masters.ffrrFinancer
            allItems = allItems.concat(Utilities.processDropDownData(allData, Enums.ListTypes.ProaSubproyectoFRStepSDC,"", "FIN"));
            allData = masters.grantCodes
            allItems = allItems.concat(Utilities.processDropDownData(allData, Enums.ListTypes.ProaSubproyectoFRStepSDC,"", "COD"));

            field.items = items;
            field.allItems = allItems;
        }
        if(fieldName === Enums.ProaBasicFields.ObjetivoEspecifico || fieldName === Enums.ProaBasicFields.PProaResultadoEsperado){
            field.width = 500;
        }
        if (fieldName === Enums.ProaBasicFields.PProaMedidaId.toString()) {
            field.items = [ ...Utilities.processDropDownData(masters.measureUnits, "", "") ];
        }
        if (fieldName === Enums.ProaBasicFields.PProaMRIPriority.toString()) {
            field.items = [
                ...Utilities.processDropDownData(masters.strategicLines, "", "", Constants.Globals.PREFIX_STRATEGIC_LINE_INDICATOR),
                ...Utilities.processDropDownData(masters.intermediateResultsIndicator, "", "", Constants.Globals.PREFIX_INTERMEDIATE_RESULTS),
                ...Utilities.processDropDownData(masters.productsIndicators, "", "", Constants.Globals.PREFIX_PRODUCT_INDICATOR),
            ];
            field.width = 450;
        }
        if (fieldName === Enums.ProaBasicFields.PProaTipoContrapartida.toString()) {
            let data = masters.counterpartType;
            field.items = Utilities.processDropDownData(data, Enums.ListTypes.ProaTipoContrapartida);
            field.allItems = Utilities.processDropDownData(data, Enums.ListTypes.ProaTipoContrapartida);
        }
        if (fieldName === Enums.ProaBasicFields.ADT.toString()) {
            let data = masters.proaAdt;
            field.items = Utilities.processDropDownData(data?.filter((x: any) => (x.OCTAVIAActivo)), Enums.ListTypes.ProaAdt);
            field.allItems = Utilities.processDropDownData(data, Enums.ListTypes.ProaAdt);
        }
        if (fieldName === Enums.ProaBasicFields.Location.toString()) {
            let data = masters.proaLocalization;    
            field.items = Utilities.processDropDownData(data?.filter((x: any) => (x.OCTAVIAActivo)), Enums.ListTypes.ProaLocalization);
            field.allItems = Utilities.processDropDownData(data, Enums.ListTypes.ProaLocalization);
        }
        if (fieldName === Enums.ProaBasicFields.Implementador.toString()) {
            let data = masters.implementators;
            field.items = Utilities.processDropDownData(data?.filter((x: any) => (x.OCTAVIAActivo)), Enums.ListTypes.SLEP);
            field.allItems = Utilities.processDropDownData(data, Enums.ListTypes.SLEP);
        }
        if (fieldName === Enums.ProaBasicFields.IndicadorLE1.toString()) {
            field.items = [ ...Utilities.processDropDownData(masters.strategicLines, "", "") ];
            field.width = 350;
        }
        if (fieldName === Enums.ProaBasicFields.PProaAnioLineaBase.toString()) {
            field.format = Constants.GeneralFormats.DATE_MESANIO_FORMAT;
            field.editorOptions = { calendarOptions : { maxZoomLevel: 'year', minZoomLevel: 'century' }};
        }
        if (fieldName === Enums.ProaBasicFields.Meta.toString() && plus) {
            field.dataField = Enums.ProaBasicFields.MetaValor;
        }
        

        return field;
    }

    private getMeasureUnitFromMRI(masters: any, currentValue: string, prefix: string){
        let selReg : any = null;

        if (!prefix){
            let productIndicatorSel = masters.productsIndicators?.filter((a:any)=> currentValue == (Constants.Globals.PREFIX_PRODUCT_INDICATOR + a.Id));
            let intermediateIndicatorSel = masters.intermediateResultsIndicator?.filter((a:any)=> currentValue == (Constants.Globals.PREFIX_INTERMEDIATE_RESULTS + a.Id));
            let strategicLinesSel = masters.strategicLines?.filter((a:any)=> currentValue == (Constants.Globals.PREFIX_STRATEGIC_LINE_INDICATOR + a.Id));

            selReg = productIndicatorSel.length > 0 ? productIndicatorSel[0] : intermediateIndicatorSel.length > 0 ? intermediateIndicatorSel[0] : strategicLinesSel.length > 0 ? strategicLinesSel[0] : "";
        } else {
            let masterQry = [];

            if (prefix === Constants.Globals.PREFIX_STRATEGIC_LINE_INDICATOR)
                masterQry = masters.strategicLines?.filter((a:any)=> currentValue == a.Id);
            else if (prefix === Constants.Globals.PREFIX_PRODUCT_INDICATOR)
                masterQry = masters.productsIndicators?.filter((a:any)=> currentValue == a.Id);
            else if (prefix === Constants.Globals.PREFIX_INTERMEDIATE_RESULTS)
                masterQry = masters.intermediateResultsIndicator?.filter((a:any)=> currentValue == a.Id);

            selReg = masterQry.length > 0 ? masterQry[0] : "";
        }
        
        let measureUnitSel = masters.measureUnits?.filter((a:any)=> selReg[Enums.ProaBasicFields.PMedidaId] == a.Id);

        return measureUnitSel.length > 0 ? measureUnitSel[0].Title : "";
    }
}

export default PopAdminPresenter;